// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:38:31.493Z
// Property: Canopy on Central (ID: 5761334570385408)
// Collections: 18 amenities, 12 floorplans (live), 24 photos, 85 POIs, 3 reviews, 1 virtual tours, 7 office hours, 1 special offers (live), 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5761334570385408",
  "property_external_id": "4600731",
  "property_zillow_url": "https://www.zillow.com/homedetails/2700-Central-Dr-Bedford-TX-76021/2060910910_zpid/",
  "property_apartments_url": "https://www.apartments.com/canopy-on-central-bedford-tx/6xfb9rt",
  "property_google_business_url": "https://www.google.com/maps/place/Canopy+on+Central/@32.8487214,-97.1315631,15z/data=!4m2!3m1!1s0x0:0x9e11b28155d35fc4?sa=X&ved=2ahUKEwjO2uqG7eH2AhU6k2oFHUUZAZAQ_BJ6BAgvEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443897720",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "canopy-on-central",
  "property_name": "Canopy on Central",
  "property_website_url": "https://www.canopyoncentral.com/",
  "property_domain": "https://www.canopyoncentral.com/",
  "property_address": "2700 Central Dr",
  "property_full_address": "2700 Central Dr, Bedford, TX 76021",
  "property_address_1": "2700 Central Dr",
  "property_address_2": null,
  "property_address_city": "Bedford",
  "property_address_state": "TX",
  "property_address_zip_full": "76021-4822",
  "property_address_zip": "76021",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "Hurst/Euless/Bedford",
  "property_address_latitude": "32.848882",
  "property_address_longitude": "-97.13262019999999",
  "property_email": "canopy@alapts.com",
  "property_phone": "(817) 858-5536",
  "property_call_tracking_phone": "817-859-7050",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Resort-style comfort in the heart of Bedford.</strong> Canopy on Central pairs garden-style one- and two-bedroom apartments with spacious closets, private patios or balconies, and everyday upgrades—all close to Mid-Cities convenience. Schedule a tour and see how home can feel here.</p>",
  "property_long_description": "<p><strong>Resort-style comfort in the heart of Bedford.</strong> At Canopy on Central, you can settle into a garden-style apartment community with room to breathe, whether you choose a one- or two-bedroom layout. Inside, look for everyday upgrades like premium appliances, a dishwasher, double-basin sinks, spacious closets, a private patio or balcony, and select homes with hardwood-style flooring, built-in bookcases, wood and creek views, washer/dryer connections, and a wood-burning fireplace.</p><p>Beyond your front door, <a href=\"/amenities\">five swimming pools with sundecks</a>, a 24-hour fitness and cardio center, clubhouse, business center, covered parking, online resident services, and <a href=\"/pet-policy\">pet-friendly</a> conveniences help keep your day moving. Bedford’s Mid-Cities location puts you close to Highway 183/121, about 10 miles from DFW Airport, with Central Drive dining and shopping nearby. Spend downtime at Generations Park at Boys Ranch, explore Central Park near Pennington Field, or connect across Dallas-Fort Worth from the CentrePort/DFW Airport TRE station.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019d02f5-3e2c-74ff-b3da-78d562ef347b.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with gray sofa, two blue armchairs, and a white coffee table.",
    "public_id": "019d02f5-3e2c-74ff-b3da-78d562ef347b",
    "storage_key": "property/5761334570385408/019d02f5-3e2c-74ff-b3da-78d562ef347b.webp",
    "width": 1240,
    "height": 825
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "706",
  "property_year_built": "1982",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.34277620396601",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Admin Fee: $150\nApplication Fee: $75\nApplication Approval Fee: Starting at $300\nNon-refundable Pet Fee: $300/pet\nMonthly Pet Rent: $20/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8113536.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://canopyoncentral.loftliving.com/login",
  "property_apply_now_url": "https://8113536.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e4380-5a44-75aa-a1c6-e874e238dfb6.webp",
  "property_primary_logo_media": {
    "alt_text": "Canopy on Central Apartment Homes logo.",
    "public_id": "019e4380-5a44-75aa-a1c6-e874e238dfb6",
    "storage_key": "property/5761334570385408/019e4380-5a44-75aa-a1c6-e874e238dfb6.webp",
    "width": 1031,
    "height": 1032
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019d02f5-30d4-754f-ac73-a387ea923c13.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f5-30d4-754f-ac73-a387ea923c13",
    "storage_key": "property/5761334570385408/019d02f5-30d4-754f-ac73-a387ea923c13.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e4380-5a44-75aa-a1c6-e874e238dfb6.webp",
  "property_icon_media": {
    "alt_text": "Canopy on Central Apartment Homes logo.",
    "public_id": "019e4380-5a44-75aa-a1c6-e874e238dfb6",
    "storage_key": "property/5761334570385408/019e4380-5a44-75aa-a1c6-e874e238dfb6.webp",
    "width": 1031,
    "height": 1032
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e4380-5a44-75aa-a1c6-e874e238dfb6.webp",
  "property_fav_icon_media": {
    "alt_text": "Canopy on Central Apartment Homes logo.",
    "public_id": "019e4380-5a44-75aa-a1c6-e874e238dfb6",
    "storage_key": "property/5761334570385408/019e4380-5a44-75aa-a1c6-e874e238dfb6.webp",
    "width": 1031,
    "height": 1032
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1552-aaec-701e-bc19-0b96dccb7a3c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f1552-aaec-701e-bc19-0b96dccb7a3c",
    "storage_key": "property/5761334570385408/019f1552-aaec-701e-bc19-0b96dccb7a3c.webp",
    "width": 1031,
    "height": 1032
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1552-9e6f-773c-ad8a-7448a7c988c2.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f1552-9e6f-773c-ad8a-7448a7c988c2",
    "storage_key": "property/5761334570385408/019f1552-9e6f-773c-ad8a-7448a7c988c2.webp",
    "width": 1031,
    "height": 1032
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#006aa6",
  "property_secondary_color": "#e77204",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#6e6e70",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "520 - 995",
  "property_sqft_min": "520",
  "property_sqft_max": "995",
  "property_price_range": "1025.5 - 1721",
  "property_price_min": "1025.5",
  "property_price_max": "1721",
  "property_available_units": 47,
  "property_facebook_url": "https://www.facebook.com/CanopyOnCentral",
  "property_instagram_url": "https://www.instagram.com/canopyoncentral",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJvw82RqF_ToYRxF_TVYGyEZ4",
  "property_youtube_url": "https://www.youtube.com/@canopyoncentralapartments",
  "property_yelp_url": "https://www.yelp.com/biz/arbors-of-central-park-bedford",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities with room to unwind.</strong> Canopy on Central brings everyday ease to Bedford living with five poolside sundecks, a 24-hour fitness and cardio center, clubhouse, business center, covered parking options, and online resident services.</p><p>At home, enjoy practical perks with character, including premium appliances, dishwashers, double-basin sinks, wood-burning fireplaces, and private patios or balconies, with select homes offering hardwood-style flooring, built-in bookcases, washer and dryer connections, and serene wood or creek views.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a layout with room for your routine.</strong> Canopy on Central offers one- and two-bedroom apartments in Bedford with smart flow, generous closets, premium kitchen appliances, dishwashers, and private patios or balconies. Select homes add hardwood-style flooring, built-in bookcases, full-size washer and dryer connections, scenic wood or creek views, and wood-burning fireplaces—details that make each floor plan feel easy to settle into.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a glimpse of Canopy on Central.</strong> Flip through Bedford apartment scenes with wood-burning fireplaces, sleek kitchen appliances, double-basin sinks, and bright pass-through layouts. Outside, preview a sparkling pool with sundecks, mature landscaping, shaded gathering spots, and inviting clubhouse spaces—all ready for a closer look in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Central Bedford keeps the Mid-Cities close.</strong> Start with coffee and errands along Central Drive, head to Twisted Root for burgers, catch dinner and a movie nearby, or shop and dine at Glade Parks off SH 121. Generations Park at Boys Ranch adds lake views, trails, green space, and recreation, while Highway 183/121 and the CentrePort/DFW Airport TRE station keep the wider DFW area within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents call out the details that make daily life easier.</strong> Reviews for Canopy on Central mention quiet surroundings, clean and well-kept apartments, helpful communication, and a management team that responds with care. Leasing support earns praise for being kind, knowledgeable, and attentive, while regular updates help keep everything clear. As one resident shared, “the vibe here is a really good one.” Read more to get a feel for Canopy on Central.</p>",
  "property_neighborhood_blurb": "<p><strong>Bedford puts the whole Mid-Cities in easy reach.</strong> From Canopy on Central, your day can move from coffee and errands along Central Drive to a burger at Twisted Root, a movie-and-dinner night nearby, or shopping and dining at Glade Parks just up SH 121. When you want fresh air, Generations Park at Boys Ranch brings lake views, trails, open green space, and recreation close to home, while Central Park adds an easy stop near Pennington Field.</p><p>Highway 183/121 keeps Dallas-Fort Worth destinations accessible, and the CentrePort/DFW Airport TRE station connects you to regional rail options. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how naturally Canopy on Central fits into Bedford life.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Your downtime has options here.</strong> At Canopy on Central, amenities are designed to make daily life feel easier, from five poolside sundecks and a 24-hour fitness and cardio center to a clubhouse, business center, covered parking options, and online resident services that keep routine tasks simple.</p><p>Inside your Bedford apartment, practical details meet a little extra character: cook with premium appliances, a dishwasher, and double-basin sink, then unwind by a wood-burning fireplace or step out to a private patio or balcony. Select homes add hardwood-style flooring, built-in bookcases, full-size washer and dryer connections, separate vanities, and calming wood or creek views. Browse the <a href=\"/gallery\">photo gallery</a>, check the <a href=\"/pet-policy\">pet policy</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Canopy on Central home?</strong> Start your online application for a one- or two-bedroom apartment with garden-style comfort, everyday in-home upgrades, and resort-inspired community spaces in the heart of Bedford. Choose the layout that fits your needs and take the next step today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Canopy on Central leasing team for details on one- and two-bedroom apartments, garden-style comfort, everyday finishes, or directions to our Bedford community near Highway 183/121.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Canopy on Central?</strong> Start here for quick answers about the garden-style community, leasing, amenities, pet-friendly conveniences, and everyday living in Bedford. If you need more details or want help finding the right one- or two-bedroom layout, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that fits your day.</strong> At Canopy on Central, you can compare streamlined one-bedroom apartments and roomier two-bedroom layouts in Bedford, each designed around practical flow, comfortable living areas, and the storage you need to stay organized.</p><p>Look for everyday details that make the floor plan feel easy to live in: premium kitchen appliances, a dishwasher, double-basin sinks, spacious closets, and a private patio or balcony for a little fresh air beyond your living room. Select homes add character and convenience with hardwood-style flooring, built-in bookcases, full-size washer and dryer connections, wood or creek views, and a wood-burning fireplace. Browse current availability, filter by layout, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which apartment feels like the right fit.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces that shape your day.</strong> Browse the Canopy on Central photo gallery for a closer look at garden-style apartments in Bedford, from light-filled living rooms with wood-burning fireplaces to kitchens with sleek appliances, double-basin sinks, and easy pass-through flow.</p><p>Picture mornings on a private patio or balcony, afternoons by a sparkling pool edged with sundecks and mature landscaping, and quick workouts in the fitness and cardio center. As you scroll, notice the details that make each scene feel complete: spacious closets, hardwood-style flooring in select homes, shaded community corners, and inviting clubhouse spaces. When a view catches your eye, explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Bedford from Canopy on Central.</strong> Use the interactive map to view available one- and two-bedroom apartments, then see what’s nearby—from Central Drive dining and shopping to quick Highway 183/121 connections, DFW Airport access, parks, and TRE transit across Dallas-Fort Worth.</p>",
  "property_pets_blurb": "<p><strong>Bring the paws, the whiskers, and the daily routine.</strong> At Canopy on Central, cats and dogs can settle into apartment life with room to lounge indoors, step out on a private patio or balcony, and enjoy strolls through a garden-style community. With two pets welcome per home and no weight limit, it is easier to choose a space around how you actually live—whether that means extra closet room for leashes and litter supplies or a layout that gives every pet a comfortable corner.</p><p>When it is time for fresh air, pet-friendly perks continue beyond your front door. The nearby Bark Park offers separate small- and large-dog areas, water fountains, cleanup stations, and agility equipment, while home keeps resort-style amenities close for your own downtime. Explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to picture your pet-friendly days here.</p>",
  "property_referafriend_blurb": "<p><strong>Share the comfort of Canopy on Central.</strong><br>Love the garden-style setting, spacious one- and two-bedroom layouts, and resort-style perks like five swimming pools? Invite a friend to experience life in the heart of Bedford—then use the referral form to help them take the next step.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access made easy.</strong><br>Log in to Canopy on Central’s online resident services to pay rent, submit maintenance requests, and manage your account—all from the garden-style comfort of your Bedford apartment community.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Canopy on Central.</strong> Reviews often highlight the everyday details that matter most: quiet surroundings, clean and well-kept apartments, friendly neighbors, and a responsive management team.</p><p>Residents praise helpful communication, from quick answers to regular updates about service work, outages, or weather. Leasing support also stands out, with team members described as kind, knowledgeable, and attentive. As one resident put it, “the vibe here is a really good one.” Read the reviews below to get a clearer feel for life at Canopy on Central.</p>",
  "property_created_at": "1752256731721",
  "property_scheduletour_blurb": "<p><strong>See Canopy on Central up close.</strong> Tour garden-style one- and two-bedroom apartments with spacious closets, private patios or balconies, and select upgrades like hardwood-style flooring, built-in bookcases, creek views, and wood-burning fireplaces. Then picture daily downtime with five pools, sundecks, and resort-style comforts in the heart of Bedford.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Canopy on Central.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture garden-style living in the heart of Bedford, with one- and two-bedroom layouts, private patios or balconies, spacious closets, and resort-style comforts designed for easy everyday living.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the community before you arrive.</strong> The Canopy on Central virtual tour lets you explore the community experience from anywhere, with a closer look at the garden-style setting, mature landscaping, poolside spaces, and everyday amenities that shape life here in Bedford.</p><p>Use the walkthrough to get a feel for the flow between outdoor gathering areas, sundecks, clubhouse conveniences, and the fitness center, then pair what you see with current <a href=\"/floor-plans\">one- and two-bedroom floor plans</a> to picture how your home base could fit into the larger community. When you are ready for the next step, browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Canopy on Central in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Canopy on Central",
  "property_seo_title_home": "Canopy on Central | Apartments in Bedford, TX",
  "property_seo_description_home": "Welcome to Canopy on Central in Bedford, TX, where modern living meets natural beauty. Choose from our thoughtfully designed one and two-bedroom floor plans with unique features like walk-in closets, built-in bookcases, and serene nature views. Enjoy top-notch amenities including a sparkling pool, fitness center, and resident clubhouse—perfect for relaxation and socializing. With online resident services and laundry connections right in your home, convenience is at your fingertips. Uncover the lifestyle you deserve and find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Bedford, TX",
  "property_seo_description_floorplans": "Unveil your ideal living space at Canopy on Central in Bedford, TX. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to suit your lifestyle. With a variety of layouts to explore, your dream apartment awaits! Browse our available homes today and step into a community where comfort meets convenience.",
  "property_seo_title_amenities": "Amenities | Bedford, TX Apartments for Rent",
  "property_seo_description_amenities": "\"Elevate your lifestyle at Canopy on Central in Bedford, TX! Indulge in modern living with our thoughtfully designed one and two-bedroom floor plans featuring luxurious amenities like a sparkling pool, fitness center, and cozy fireplaces. Enjoy convenient online resident services, spacious walk-in closets, and nature views that make each day more delightful. With covered parking and inviting outdoor spaces, our community is designed for relaxation and connection. Uncover the unique charm of Canopy on Central today!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Bedford, TX",
  "property_seo_description_gallery": "\"Step into the vibrant lifestyle at Canopy on Central in Bedford, TX, where every corner invites you to unwind. From the modern elegance of our one and two-bedroom floor plans to the lush nature views, find your perfect home with amenities like a refreshing pool, state-of-the-art fitness center, and cozy fireplaces. Picture yourself enjoying the resident clubhouse, cozy up by the double vanity, or bask in the beauty of your private outdoor space. Your next chapter starts here—take a look at our stunning photo gallery and envision living in luxury!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Canopy on Central Apartments",
  "property_seo_description_virtualtours": "Step into your next home at Canopy on Central in Bedford, TX! Immerse yourself in our beautifully designed one and two-bedroom apartment floor plans through an engaging virtual tour. Experience the vibrant community and stunning amenities that make every day extraordinary. Ready to envision your new lifestyle? Join us online today!",
  "property_seo_title_interactivemap": "Interactive Map | Canopy on Central Apartments",
  "property_seo_description_interactivemap": "Unveil your ideal living space at Canopy on Central in Bedford, TX. With spacious one and two-bedroom floor plans, each home features modern amenities like fire places, built-in bookcases, and cozy patios. Enjoy resort-style living with a sparkling pool, a fully-equipped fitness center, and serene nature views. Experience the seamless convenience of online resident services and in-home laundry options. Dive into your apartment search with our interactive community map—find your perfect fit today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bedford, TX",
  "property_seo_description_neighborhood": "Experience life at Canopy on Central in Bedford, TX, where modern living meets local charm. Our vibrant neighborhood is brimming with hidden gems, favorite eateries, and convenient hotspots. Uncover everything from serene parks to eclectic shops right outside your door. See what's around our community and immerse yourself in the best of Bedford!",
  "property_seo_title_contact": "Contact Us | Canopy on Central",
  "property_seo_description_contact": "Experience modern living at Canopy on Central in Bedford, TX, where our diverse floor plans—from cozy one-bedroom retreats to spacious two-bedroom havens—cater to your lifestyle. Have questions? Our leasing team is eager to assist you on your journey to finding your perfect home. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Bedford, TX",
  "property_seo_description_faqs": "Uncover the answers to your burning questions about life at Canopy on Central in Bedford, TX. Our Frequently Asked Questions page sheds light on everything from luxury floor plans—including stylish one and two-bedroom apartments—to our top-notch amenities like our resort-style pool, fitness center, and resident clubhouse. Whether you're curious about covered parking options or the tranquility of nature views from select homes, we’ve got you covered. Dive in now and let us help you envision your future at Canopy on Central!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bedford, TX",
  "property_seo_description_reviews": "Experience the vibrant community at Canopy on Central in Bedford, TX! With thoughtfully designed one and two-bedroom floor plans and a wealth of amenities—like stunning nature views, inviting fire and fitness centers, and cozy resident clubhouses—our homes create a perfect blend of comfort and style. Curious about the life here? Dive into authentic resident reviews and find out what makes our community truly special!",
  "property_seo_title_applynow": "Apply Now | Apartments in Bedford, TX",
  "property_seo_description_applynow": "\"Step into a lifestyle of comfort and convenience at Canopy on Central in Bedford, TX. Our thoughtfully designed one and two-bedroom apartment floor plans feature luxurious amenities, including a fitness center, inviting pool, and cozy fireplaces. Enjoy modern touches like built-in bookcases, walk-in closets, and wood plank style flooring, paired with stunning views of nature. With online resident services and a welcoming clubhouse, your new home awaits. Don’t wait—secure your place with us today!\"",
  "property_seo_title_residentaccess": "Resident Access | Canopy on Central",
  "property_seo_description_residentaccess": "\"Welcome to Canopy on Central, your gateway to effortless living in Bedford, TX. Access your resident portal now to manage rent payments, schedule maintenance, and streamline your community experience—all at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | Canopy on Central",
  "property_seo_description_referafriend": "\"Share the joy of living at Canopy on Central in Bedford, TX! Invite a friend to join our vibrant community and enjoy exclusive perks together. After all, great friends make the best neighbors—refer someone special today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Canopy on Central",
  "property_seo_description_scheduletour": "\"Experience the vibrant lifestyle you’ve been searching for at Canopy on Central in Bedford, TX. Immerse yourself in our stunning amenities and welcoming community. Schedule a tour today to see your future home where comfort meets convenience!\"",
  "property_seo_title_privacy": "Privacy Policy | Canopy on Central",
  "property_seo_description_privacy": "\"At Canopy on Central in Bedford, TX, your privacy is our priority. Delve into our comprehensive privacy policy to understand how we protect your personal information while you enjoy the tranquility of upscale living. Your peace of mind starts here—view our policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Canopy on Central",
  "property_seo_description_accessibility": "\"At Canopy on Central in Bedford, TX, we believe that everyone deserves access to information and community. Our Accessibility Statement outlines our commitment to digital inclusion and ensures a welcoming online experience for all. Join us in fostering an inclusive environment—because everyone’s voice matters.\"",
  "property_seo_title_sitemap": "Sitemap | Canopy on Central",
  "property_seo_description_sitemap": "Unearth the intricacies of Canopy on Central in Bedford, TX. Our sitemap reveals everything you need to navigate your future home, showcasing amenities, floor plans, and community perks. Dive in and see where your next chapter begins!",
  "property_seo_title_thankyou": "Thank You | Canopy on Central",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Canopy on Central! We appreciate your interest in our vibrant Bedford community. One of our friendly team members will be in touch soon to help you explore your future home. Your journey to exceptional living starts here!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319453",
  "amenities": [
    {
      "id": "custom_aab007af-1a43-4d46-b050-cdd41d43ccb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7f0d5e8-f222-4f21-84a7-e35de989d798",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "5 Resort-Inspired Pools w/ Sundecks",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28644ff7-4854-4f2f-9207-408ef8a1817a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Clubhouse & Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_198e11c6-0c8f-4e9b-aca8-63a67bca4f86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_939bf4a3-5eaa-4e70-b9cd-9e64e6ea38d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9bda67a0-638b-4da0-80e4-3d2e8e9ae627",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52d18b10-5a5d-48a8-a15a-02770a93f4e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "Onsite Resident Laundry Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a3e097a1-e2f5-4cca-901a-aa25cc0d8642",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000604",
      "title": "Built-In Bookcase",
      "amount": "0.0000",
      "description": "Built-In Bookcase*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d2eaf41-35b2-4116-ab54-228d5c8d45b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000629",
      "title": "Double Vanity",
      "amount": "0.0000",
      "description": "Separate Vanity*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f8d4673-c5ac-4bbf-b3f2-a82890b9bac0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Wood-Burning Fireplace",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7dbc3c77-8ce3-4894-9475-becbc3be5f10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood-Style Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_41316d7b-4dba-475d-b561-d6419126ed4a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Double Basin Kitchen Sinks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_754e82cd-6323-426c-910e-2647fbd62f9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000696",
      "title": "Townhomes",
      "amount": "0.0000",
      "description": "Townhome Floorplans Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d75c9b3-ffbd-4db4-8ebd-7196f64efed1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000700",
      "title": "Views",
      "amount": "0.0000",
      "description": "Wood & Creek Views*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9128ca4-450e-4af8-8c1b-d0fc93f8b475",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer & Dryer Connections*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba490593-f761-4801-a84c-3308bed25972",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Spacious Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52b3f912-d463-4b96-8c97-7aa7b3f5e212",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patio or Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69e5edb8-90e5-415e-87c2-70adf2034e07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_9278189e-5d6d-4a5e-9db2-4a8662df2143",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-28df-740a-a325-94ea9e1ff70f.webp",
      "image_media": {
        "alt_text": "Modern living room with a fireplace, TV, and a blue sectional sofa.",
        "public_id": "019e8982-28df-740a-a325-94ea9e1ff70f",
        "storage_key": "property/5761334570385408/019e8982-28df-740a-a325-94ea9e1ff70f.webp",
        "width": 3014,
        "height": 2006
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a white brick fireplace with a mounted TV, a large blue sectional sofa, and a round coffee table on a plush rug.",
      "link": "",
      "alt_text": "Modern living room with a fireplace, TV, and a blue sectional sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0876af33-320a-4c94-8cc6-b3580dc197f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-2625-72cd-bcfb-b59fd4e76c31.webp",
      "image_media": {
        "alt_text": "Exterior of the leasing office with a brick facade and a covered entrance.",
        "public_id": "019e8982-2625-72cd-bcfb-b59fd4e76c31",
        "storage_key": "property/5761334570385408/019e8982-2625-72cd-bcfb-b59fd4e76c31.webp",
        "width": 2315,
        "height": 1544
      },
      "title": "Community",
      "description": "Welcome to our community's leasing office, featuring a charming brick exterior and an inviting covered entryway. Discover your new home with us.",
      "link": "",
      "alt_text": "Exterior of the leasing office with a brick facade and a covered entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_40e40440-fa88-4bcf-947d-0a13e509dc9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-268c-745f-bf3d-04255f85f04f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019e8982-268c-745f-bf3d-04255f85f04f",
        "storage_key": "property/5761334570385408/019e8982-268c-745f-bf3d-04255f85f04f.webp",
        "width": 2531,
        "height": 1684
      },
      "title": "Apartment",
      "description": "Upgrade your culinary experience in this beautifully appointed kitchen, featuring sleek dark wood cabinetry, elegant granite countertops, and modern stainless steel appliances. The classic white subway tile backsplash adds a touch of timeless style.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_254f8522-e810-431a-b024-2002018abd03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-1b80-7122-b860-6f78fe0cdd25.webp",
      "image_media": {
        "alt_text": "Stylish living room with a sofa, armchair, coffee table, and TV.",
        "public_id": "019e8982-1b80-7122-b860-6f78fe0cdd25",
        "storage_key": "property/5761334570385408/019e8982-1b80-7122-b860-6f78fe0cdd25.webp",
        "width": 2912,
        "height": 1938
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room. Featuring a plush sofa, elegant armchair, and modern decor, it's the perfect space for relaxation and entertainment.",
      "link": "",
      "alt_text": "Stylish living room with a sofa, armchair, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c426583b-4599-4058-99aa-40481b2bc744",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-17b6-7130-9aa8-cfce9eea2f1c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, tables, and umbrellas.",
        "public_id": "019e8982-17b6-7130-9aa8-cfce9eea2f1c",
        "storage_key": "property/5761334570385408/019e8982-17b6-7130-9aa8-cfce9eea2f1c.webp",
        "width": 3007,
        "height": 2005
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling outdoor swimming pool, complete with comfortable lounge seating and shaded areas for your convenience.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, tables, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_225e0022-adb2-4692-ba83-ec9b2a207d39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-166a-7682-a866-4bafcc4d27ed.webp",
      "image_media": {
        "alt_text": "Stylish living room with a TV, mirrored wall art, and comfortable seating.",
        "public_id": "019e8982-166a-7682-a866-4bafcc4d27ed",
        "storage_key": "property/5761334570385408/019e8982-166a-7682-a866-4bafcc4d27ed.webp",
        "width": 2767,
        "height": 1841
      },
      "title": "Apartment",
      "description": "A beautifully decorated living room featuring a wall-mounted TV, elegant mirrored wall art, and plush seating arrangements, perfect for relaxation.",
      "link": "",
      "alt_text": "Stylish living room with a TV, mirrored wall art, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6b4d41c-9f7c-4be4-b2c5-3da62eac6126",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-141f-7507-a0c3-d2996a7a6841.webp",
      "image_media": {
        "alt_text": "Outdoor patio with comfortable seating and a coffee table, shaded by a wooden pergola.",
        "public_id": "019e8982-141f-7507-a0c3-d2996a7a6841",
        "storage_key": "property/5761334570385408/019e8982-141f-7507-a0c3-d2996a7a6841.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind on the spacious outdoor patio, featuring comfortable seating and a coffee table. The wooden pergola provides ample shade for a perfect outdoor retreat.",
      "link": "",
      "alt_text": "Outdoor patio with comfortable seating and a coffee table, shaded by a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f59a662a-83c7-4c39-8e65-d8ad0e0cd5d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-1de3-771e-b751-5781eba4d2ac.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs with a building in the background.",
        "public_id": "019e8982-1de3-771e-b751-5781eba4d2ac",
        "storage_key": "property/5761334570385408/019e8982-1de3-771e-b751-5781eba4d2ac.webp",
        "width": 3032,
        "height": 2022
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling pool, complete with comfortable lounge chairs for ultimate relaxation. The perfect place to unwind.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs with a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_868d0f00-3a53-4d1f-9269-844ea3ae4101",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-08de-725a-8e7c-d66ebec6c9fa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a subway tile backsplash.",
        "public_id": "019e8982-08de-725a-8e7c-d66ebec6c9fa",
        "storage_key": "property/5761334570385408/019e8982-08de-725a-8e7c-d66ebec6c9fa.webp",
        "width": 2216,
        "height": 1474
      },
      "title": "Apartment",
      "description": "Discover the stylish and functional kitchen in our apartments, featuring dark wood cabinetry, elegant granite countertops, and modern stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_838d1769-19a6-4ff4-9552-92430b843ca6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-0af8-752e-8bbd-2bb1fb135314.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two built-in barbecues next to a swimming pool.",
        "public_id": "019e8982-0af8-752e-8bbd-2bb1fb135314",
        "storage_key": "property/5761334570385408/019e8982-0af8-752e-8bbd-2bb1fb135314.webp",
        "width": 2896,
        "height": 1931
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining with our premium grilling stations, perfect for a summer cookout by the pool.",
      "link": "",
      "alt_text": "Outdoor grilling station with two built-in barbecues next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b251ac1-48c6-4587-8e37-f1ecbc970918",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-09f2-70ff-ba28-240645c306ed.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with a stainless steel grill and granite countertop, adjacent to a table and chairs under umbrellas.",
        "public_id": "019e8982-09f2-70ff-ba28-240645c306ed",
        "storage_key": "property/5761334570385408/019e8982-09f2-70ff-ba28-240645c306ed.webp",
        "width": 2816,
        "height": 1877
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our built-in grill and comfortable seating area. Perfect for gatherings with friends and family.",
      "link": "",
      "alt_text": "Outdoor grilling station with a stainless steel grill and granite countertop, adjacent to a table and chairs under umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c29afda-db5b-4f11-b047-da0defb7992b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-0c65-73ad-8a44-40380a7410ff.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019e8982-0c65-73ad-8a44-40380a7410ff",
        "storage_key": "property/5761334570385408/019e8982-0c65-73ad-8a44-40380a7410ff.webp",
        "width": 3014,
        "height": 2005
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a vanity with modern fixtures, a toilet, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a54ee2ec-07dd-4b47-9b77-6930d5bf3293",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-0627-733d-b620-86f80d58a312.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with stainless steel appliances and dark wood cabinets.",
        "public_id": "019e8982-0627-733d-b620-86f80d58a312",
        "storage_key": "property/5761334570385408/019e8982-0627-733d-b620-86f80d58a312.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Stylish dining area adjacent to a modern kitchen featuring stainless steel appliances and ample cabinet space, perfect for entertaining.",
      "link": "",
      "alt_text": "Dining area and kitchen with stainless steel appliances and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce8e305f-203d-46d5-9fc7-f9a638ff910b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8982-04ae-7692-9b56-4fde4a8ba57d.webp",
      "image_media": {
        "alt_text": "Chairs and pool with gazebo in the background",
        "public_id": "019e8982-04ae-7692-9b56-4fde4a8ba57d",
        "storage_key": "property/5761334570385408/019e8982-04ae-7692-9b56-4fde4a8ba57d.webp",
        "width": 2479,
        "height": 1653
      },
      "title": "Community",
      "description": "Relax by the pool or under the gazebo. Enjoy the outdoor amenities.",
      "link": "",
      "alt_text": "Chairs and pool with gazebo in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_492b497e-aa34-414b-916e-705ff1683f30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-efb9-7401-9b7d-e0cec04e0b45.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019e8981-efb9-7401-9b7d-e0cec04e0b45",
        "storage_key": "property/5761334570385408/019e8981-efb9-7401-9b7d-e0cec04e0b45.webp",
        "width": 2406,
        "height": 1604
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, complete with comfortable lounge chairs and a charming gazebo.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60cbcca4-5641-4045-9784-31aba87aeb9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-f34b-70eb-a337-416290d3b56c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019e8981-f34b-70eb-a337-416290d3b56c",
        "storage_key": "property/5761334570385408/019e8981-f34b-70eb-a337-416290d3b56c.webp",
        "width": 2690,
        "height": 1793
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and a charming gazebo for shaded relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a5a1b54-70a6-45f3-9061-ed52d8e9daf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-f09d-733c-a2b0-83f1f8491fde.webp",
      "image_media": {
        "alt_text": "Canopy on Central premier apartments monument sign.",
        "public_id": "019e8981-f09d-733c-a2b0-83f1f8491fde",
        "storage_key": "property/5761334570385408/019e8981-f09d-733c-a2b0-83f1f8491fde.webp",
        "width": 2584,
        "height": 1723
      },
      "title": "Community",
      "description": "Welcome to Canopy on Central, offering premier apartment living. Explore our community amenities and find your perfect home.",
      "link": "",
      "alt_text": "Canopy on Central premier apartments monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a95ec6a-bc92-444e-9456-925ac35b6dfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-f0e4-74f4-8083-b71835dd3521.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019e8981-f0e4-74f4-8083-b71835dd3521",
        "storage_key": "property/5761334570385408/019e8981-f0e4-74f4-8083-b71835dd3521.webp",
        "width": 2229,
        "height": 1486
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and unwinding under the sun. Surrounded by lush landscaping and comfortable lounge seating, it's the ideal spot to escape the everyday.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_84145d5a-e291-4117-a7a8-d0581bae4f09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-f230-75bd-9898-93a19d73f9e0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019e8981-f230-75bd-9898-93a19d73f9e0",
        "storage_key": "property/5761334570385408/019e8981-f230-75bd-9898-93a19d73f9e0.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation. Surrounded by beautiful landscaping and apartment buildings, it's the perfect place to unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0139b71e-34b7-4cf5-b16b-d204e3671d11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-f2be-76ec-bd62-47e47acc7185.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, dresser, and artwork.",
        "public_id": "019e8981-f2be-76ec-bd62-47e47acc7185",
        "storage_key": "property/5761334570385408/019e8981-f2be-76ec-bd62-47e47acc7185.webp",
        "width": 2411,
        "height": 1604
      },
      "title": "Apartment",
      "description": "Spacious and inviting bedroom featuring a comfortable king-size bed, stylish nightstands, and ample storage with a dresser. Decorated with modern artwork and soft lighting for a relaxing ambiance.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, dresser, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_475aaf8e-b1d5-44d0-a3a6-17701ce9e596",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-f283-77e4-936d-75e38bb48cce.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, TV, sectional sofa, and coffee table.",
        "public_id": "019e8981-f283-77e4-936d-75e38bb48cce",
        "storage_key": "property/5761334570385408/019e8981-f283-77e4-936d-75e38bb48cce.webp",
        "width": 2411,
        "height": 1604
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, mounted TV, comfortable sectional sofa, and a stylish coffee table, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, TV, sectional sofa, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16258785-a554-43a8-86ba-ee2b75179dd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-f490-711f-b875-b4dbff84ce13.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, two blue accent chairs, and a white oval coffee table.",
        "public_id": "019e8981-f490-711f-b875-b4dbff84ce13",
        "storage_key": "property/5761334570385408/019e8981-f490-711f-b875-b4dbff84ce13.webp",
        "width": 2242,
        "height": 1492
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sofa, chic blue accent chairs, and a modern coffee table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a gray sofa, two blue accent chairs, and a white oval coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_185ad5db-0ea2-4887-91c8-0b4976747a6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-ef3f-72b2-9a59-d0a58244fc61.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a large sink.",
        "public_id": "019e8981-ef3f-72b2-9a59-d0a58244fc61",
        "storage_key": "property/5761334570385408/019e8981-ef3f-72b2-9a59-d0a58244fc61.webp",
        "width": 2310,
        "height": 1537
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring dark wood cabinetry, sleek granite countertops, and modern stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e84da79-2ec8-4b87-aa96-c7f13d755e31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019e8981-ef42-75a4-9fe9-4457232199bf.webp",
      "image_media": {
        "alt_text": "Dining room with a table set for four people, featuring a bookshelf and abstract art.",
        "public_id": "019e8981-ef42-75a4-9fe9-4457232199bf",
        "storage_key": "property/5761334570385408/019e8981-ef42-75a4-9fe9-4457232199bf.webp",
        "width": 2478,
        "height": 1649
      },
      "title": "Apartment",
      "description": "A stylish dining room setup, perfect for hosting guests, with a table set for four, modern decor, and a decorative bookshelf.",
      "link": "",
      "alt_text": "Dining room with a table set for four people, featuring a bookshelf and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_fc952b5914f0634b821f50c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Bleu Bear Sushi, Bedford, TX",
      "poi_type": "Restaurants",
      "poi_address": "2807 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Relaxed restaurant specializing in sushi in a variety of rolls (including signature ones).",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-d589-770c-bf44-b20b8794fd8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-d589-770c-bf44-b20b8794fd8e",
        "storage_key": "property/5761334570385408/019f1512-d589-770c-bf44-b20b8794fd8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bleubearsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8003033122951115561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bleu-bear-sushi-bedford-tx",
      "poi_latitude": "32.8500457",
      "poi_longitude": "-97.1325515",
      "poi_miles_from_property": "469 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 682-503-6312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyD0czp_ToYRKbMvMzl8EG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_2a0a2df7b305c531675008c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Twisted Root Burger Co.",
      "poi_type": "Restaurants",
      "poi_address": "2820 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Gourmet burger chain with beef, turkey & vegan options (some offer game meats), plus spiked shakes.",
      "poi_long_description": "Gourmet burger chain with beef, turkey & vegan options (some offer game meats), plus spiked shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-d54f-730e-a339-b153c3a1ed1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-d54f-730e-a339-b153c3a1ed1b",
        "storage_key": "property/5761334570385408/019f1512-d54f-730e-a339-b153c3a1ed1b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.twistedrootburgerco.com/locations/bedford",
      "poi_directions_map_url": "https://maps.google.com/?cid=1441156698971658199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twisted-root-burger-co",
      "poi_latitude": "32.8514302",
      "poi_longitude": "-97.1313317",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 682-444-5650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTPCk6F_ToYR11fh02EEABQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_276c3f5fd84713405e419c89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Danny's Celtic Pub",
      "poi_type": "Restaurants",
      "poi_address": "2824 Central Dr #301, Bedford, TX 76021, USA",
      "poi_short_description": "Laid-back pub with an Irish theme offering sports on TV, live entertainment & an outdoor patio.",
      "poi_long_description": "Laid-back pub with an Irish theme offering sports on TV, live entertainment & an outdoor patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-d5fc-71c6-8018-3762dee7c95b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-d5fc-71c6-8018-3762dee7c95b",
        "storage_key": "property/5761334570385408/019f1512-d5fc-71c6-8018-3762dee7c95b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://dannyscelticpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10908294468131773396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dannys-celtic-pub",
      "poi_latitude": "32.8511317",
      "poi_longitude": "-97.1299134",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-571-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-51cf-7014-8035-490656681a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-51cf-7014-8035-490656681a83",
        "storage_key": "property/5761334570385408/019f1513-51cf-7014-8035-490656681a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJne4RL6J_ToYR1FtaLgYMYpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_f4eeca707f527b59c70f746a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Coffee Tea & Books",
      "poi_type": "Restaurants",
      "poi_address": "2813 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Cozy, book-friendly coffee shop with pastries, tea, and a selection of board games.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-da41-75c9-84eb-c9040892800e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-da41-75c9-84eb-c9040892800e",
        "storage_key": "property/5761334570385408/019f1512-da41-75c9-84eb-c9040892800e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coffeeteaandbooks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9647739746328628929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coffee-tea--books",
      "poi_latitude": "32.850103",
      "poi_longitude": "-97.1326987",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 817-940-3646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-5280-7743-ba56-334eea7c5f0b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-5280-7743-ba56-334eea7c5f0b",
        "storage_key": "property/5761334570385408/019f1513-5280-7743-ba56-334eea7c5f0b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtXfjQMl_ToYRwc5V8S6o44U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_e23684eababe1cfa040019ca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Lina Street Food",
      "poi_type": "Restaurants",
      "poi_address": "2208 Central Dr #130, Bedford, TX 76021, USA",
      "poi_short_description": "Popular destination for traditional Thai dishes, including soups, curries and pad thai.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-da45-779d-bb3e-80aa9a098d1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-da45-779d-bb3e-80aa9a098d1e",
        "storage_key": "property/5761334570385408/019f1512-da45-779d-bb3e-80aa9a098d1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://linasstreetfood.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=14399064978769519647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lina-street-food",
      "poi_latitude": "32.8423007",
      "poi_longitude": "-97.1328591",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-503-6297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWXbegGF_ToYRHyRTBU_B08c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_3a15abfa4c590183994cfbb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Royal Mansion Restaurant And Bar",
      "poi_type": "Restaurants",
      "poi_address": "2855 Central Dr #2855, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-d551-7729-ab14-a9d7e23caf38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-d551-7729-ab14-a9d7e23caf38",
        "storage_key": "property/5761334570385408/019f1512-d551-7729-ab14-a9d7e23caf38.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "http://royalmansionbedford.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9831755396079407117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royal-mansion-restaurant-and-bar",
      "poi_latitude": "32.8514449",
      "poi_longitude": "-97.1333237",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-503-4029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO5aIqUV_ToYRDdDXHXFpcYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_074e35ecf70cb233d34dbbd9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "2252 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_long_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-d6a4-76a6-8de9-17c76319a4a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-d6a4-76a6-8de9-17c76319a4a5",
        "storage_key": "property/5761334570385408/019f1512-d6a4-76a6-8de9-17c76319a4a5.webp",
        "width": 1280,
        "height": 811
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/tx/bedford/1005?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=1464531025222548202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "32.8443096",
      "poi_longitude": "-97.1330676",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-358-8641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ1VrU6Z_ToYR6rrtQDUPUxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_7003ed3b7d6afca4fbabb0e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Bubble & Bean Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2901 Martin Dr # A, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e019-77d3-9558-5bb4bdb8e9be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e019-77d3-9558-5bb4bdb8e9be",
        "storage_key": "property/5761334570385408/019f1512-e019-77d3-9558-5bb4bdb8e9be.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://bubbleandbeancafe.toast.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13954212328079002580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bubble--bean-cafe",
      "poi_latitude": "32.8525062",
      "poi_longitude": "-97.1174072",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 682-738-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9W6TuObdTYYR1IuGBy5Sp8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "ec_93836db2b04543e8d2a0ef79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Koracha Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "229 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Thai dishes such as pad Thai and curry at a casual eatery with outdoor tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-da4a-74d8-8b8a-2224f4744e1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-da4a-74d8-8b8a-2224f4744e1b",
        "storage_key": "property/5761334570385408/019f1512-da4a-74d8-8b8a-2224f4744e1b.webp",
        "width": 1280,
        "height": 769
      },
      "poi_business_url": "https://www.koracha.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7618658814810782558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "koracha-thai-restaurant",
      "poi_latitude": "32.8513318",
      "poi_longitude": "-97.1675569",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 682-417-1353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Uuq-ZJ_ToYRXvuxodPpumk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_5f54a1a58f7c40f30d968329",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Los Jimadores Tex-Mex Tequila Factory",
      "poi_type": "Restaurants",
      "poi_address": "3314 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Tex-Mex eatery featuring a hearty menu, margaritas, murals & live music.",
      "poi_long_description": "Tex-Mex eatery featuring a hearty menu, margaritas, murals & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-dbce-73ba-b9fd-13831b3c7819.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-dbce-73ba-b9fd-13831b3c7819",
        "storage_key": "property/5761334570385408/019f1512-dbce-73ba-b9fd-13831b3c7819.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://losjimadoresfw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2776959099413473596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-jimadores-tex-mex-tequila-factory",
      "poi_latitude": "32.8506985",
      "poi_longitude": "-97.1137303",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-354-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyFiYsB_ToYRPClUhJa9iSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_45465e7b7cca2d8e44038d2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Alwadi Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2712 Brown Trail, Bedford, TX 76021, USA",
      "poi_short_description": "Cozy BYOB boasting a lunch buffet some days & hookah patio plus a menu of Lebanese & Greek cuisine.",
      "poi_long_description": "Cozy BYOB boasting a lunch buffet some days & hookah patio plus a menu of Lebanese & Greek cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e28c-71a2-877b-cfa3eaf92a2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e28c-71a2-877b-cfa3eaf92a2a",
        "storage_key": "property/5761334570385408/019f1512-e28c-71a2-877b-cfa3eaf92a2a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://alwadicafetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8256482531436444206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alwadi-cafe",
      "poi_latitude": "32.850807",
      "poi_longitude": "-97.159723",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-282-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb7PKmz9_ToYRLrp8HB7rlHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "ec_f6d9f515f6cafc7e329ef9b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Anita's MoMo",
      "poi_type": "Restaurants",
      "poi_address": "3708 Cheyenne St, Irving, TX 75038, USA",
      "poi_short_description": "Nepalese eatery serving a menu of classic dishes, including momos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e285-706e-bbb4-39cf912ea4dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e285-706e-bbb4-39cf912ea4dc",
        "storage_key": "property/5761334570385408/019f1512-e285-706e-bbb4-39cf912ea4dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anitamomo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13198425741988050819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anitas-momo",
      "poi_latitude": "32.8575386",
      "poi_longitude": "-97.0010879",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-565-2517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7bji6t_ToYRg7eRuUg6Krc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_41e274fbe7ad80ca07bf161a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Fazenda Gaúcha Brazilian Steakhouse - DFW",
      "poi_type": "Restaurants",
      "poi_address": "405 E Pipeline Rd, Bedford, TX 76022, USA",
      "poi_short_description": "Cozy, family-owned Brazilian chophouse with an all-you-can-eat, meat-centric menu & a salad bar.",
      "poi_long_description": "Cozy, family-owned Brazilian chophouse with an all-you-can-eat, meat-centric menu & a salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e8a9-709d-9297-00093059a869.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e8a9-709d-9297-00093059a869",
        "storage_key": "property/5761334570385408/019f1512-e8a9-709d-9297-00093059a869.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fazendagaucha.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6202224348911853940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fazenda-gacha-brazilian-steakhouse---dfw",
      "poi_latitude": "32.823736",
      "poi_longitude": "-97.158986",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-786-8310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVUJdd5-ToYRdGErPi-6ElY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "ec_fd20dc28e6228def71dbaef2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "El Paisa Cocina Mexicana",
      "poi_type": "Restaurants",
      "poi_address": "2801 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Local counter-serve chain offering traditional Mexican dishes in a low-key setting.",
      "poi_long_description": "Local counter-serve chain offering traditional Mexican dishes in a low-key setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e469-702f-b27a-04ce7e8bf973.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e469-702f-b27a-04ce7e8bf973",
        "storage_key": "property/5761334570385408/019f1512-e469-702f-b27a-04ce7e8bf973.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://elpaisacocina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11344888946672662898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-paisa-cocina-mexicana",
      "poi_latitude": "32.852397",
      "poi_longitude": "-97.1200188",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-481-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRny3r1_ToYRcvmtomMkcZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_a6b77801c4aca372cef6fc47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Buttermilk Cafe",
      "poi_type": "Restaurants",
      "poi_address": "337 E Pipeline Rd, Bedford, TX 76022, USA",
      "poi_short_description": "Hearty, homestyle American breakfast, lunch & dinner served in a relaxed setting.",
      "poi_long_description": "Hearty, homestyle American breakfast, lunch & dinner served in a relaxed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e3f6-719b-9677-0a7ca88f3fd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e3f6-719b-9677-0a7ca88f3fd9",
        "storage_key": "property/5761334570385408/019f1512-e3f6-719b-9677-0a7ca88f3fd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://buttermilkcafebakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7443319452168348457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buttermilk-cafe",
      "poi_latitude": "32.8237492",
      "poi_longitude": "-97.1617571",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-285-9340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f13-7150-9760-92f3c35885e5",
        "storage_key": "property/5761334570385408/019f1510-9f13-7150-9760-92f3c35885e5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRjeo95-ToYRKeM_-Jr7S2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_df4ae5c0d8cd1621667d5010",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Trail Creek Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 Tibbets Dr #200, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e4bc-71a7-ba65-ef5278e4fbb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e4bc-71a7-ba65-ef5278e4fbb7",
        "storage_key": "property/5761334570385408/019f1512-e4bc-71a7-ba65-ef5278e4fbb7.webp",
        "width": 960,
        "height": 435
      },
      "poi_business_url": "https://www.trailcreekpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5218543994494075815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trail-creek-pharmacy",
      "poi_latitude": "32.83247",
      "poi_longitude": "-97.122741",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-684-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-51c7-77de-b940-0376116f076a",
        "storage_key": "property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLTA6XbN_ToYRp0ORLB3-a0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_53f78d9e0900732c47f2974f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2900 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e7e3-75dc-b116-52c4e9088310.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e7e3-75dc-b116-52c4e9088310",
        "storage_key": "property/5761334570385408/019f1512-e7e3-75dc-b116-52c4e9088310.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bedford-tx-pharmacies/2900-central-dr-bedford-tx-76021/storeid=7449?WT.mc_id=LS_GOOGLE_RX_7449",
      "poi_directions_map_url": "https://maps.google.com/?cid=14103719006248815440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8524047",
      "poi_longitude": "-97.1315133",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-571-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-51c7-77de-b940-0376116f076a",
        "storage_key": "property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNUWB5aF_ToYRUMtiI7Z5usM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_618b31dddeff896e4de02e7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "2847 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e85a-71ad-8739-739e68345b43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e85a-71ad-8739-739e68345b43",
        "storage_key": "property/5761334570385408/019f1512-e85a-71ad-8739-739e68345b43.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tx/bedford/11125",
      "poi_directions_map_url": "https://maps.google.com/?cid=7770710409741219761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "32.8506879",
      "poi_longitude": "-97.1332035",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-908-0008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2f-72cd-b1f6-a970b9c34e2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2f-72cd-b1f6-a970b9c34e2e",
        "storage_key": "property/5761334570385408/019f1510-9f2f-72cd-b1f6-a970b9c34e2e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs6A9oqF_ToYRsTcOWfIb12s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_57afa8f9f7853d2dc799cf7e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "2253 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e98f-707c-b295-b5640560583d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e98f-707c-b295-b5640560583d",
        "storage_key": "property/5761334570385408/019f1512-e98f-707c-b295-b5640560583d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2253+central+dr-bedford-tx-76021/id=3881",
      "poi_directions_map_url": "https://maps.google.com/?cid=13275929325986654885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.844242",
      "poi_longitude": "-97.1341074",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-868-9202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJif_Xpad_ToYRpSqgEmKTPbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_8e3f216f1df93ed1ba422f03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e9ef-76da-84fd-558880a22bbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e9ef-76da-84fd-558880a22bbf",
        "storage_key": "property/5761334570385408/019f1512-e9ef-76da-84fd-558880a22bbf.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/tx/bedford/2201-central-dr?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ1MTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6551659232165092394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "32.8416463",
      "poi_longitude": "-97.1342799",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-358-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-5230-71bd-a2d5-2dd753de1b54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-5230-71bd-a2d5-2dd753de1b54",
        "storage_key": "property/5761334570385408/019f1513-5230-71bd-a2d5-2dd753de1b54.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRLZdqh_ToYRKtybBlwr7Fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_2b5335a3a54b0588f9e113c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2109 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-ea55-7524-b0e8-6259224da5ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-ea55-7524-b0e8-6259224da5ba",
        "storage_key": "property/5761334570385408/019f1512-ea55-7524-b0e8-6259224da5ba.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/bedford/bedford/035/00521?cid=loc_03500521_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3896871285611125210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.8535757",
      "poi_longitude": "-97.1332035",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-685-9266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9eb3-73b5-a360-a03507e5049e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9eb3-73b5-a360-a03507e5049e",
        "storage_key": "property/5761334570385408/019f1510-9eb3-73b5-a360-a03507e5049e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fU2PKB_ToYR2llFqsl3FDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_dff6475c3af6cee1221b5d6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2108 Bedford Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Chain supermarket offering groceries, electronics, furniture, appliances, and other merchandise, plus check cashing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-eb6b-7732-976f-35699f759331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-eb6b-7732-976f-35699f759331",
        "storage_key": "property/5761334570385408/019f1512-eb6b-7732-976f-35699f759331.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/3392-bedford-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9243868335846487013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.8436418",
      "poi_longitude": "-97.1322989",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-283-9841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9eb3-73b5-a360-a03507e5049e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9eb3-73b5-a360-a03507e5049e",
        "storage_key": "property/5761334570385408/019f1510-9eb3-73b5-a360-a03507e5049e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5OJCqd_ToYR5XOcfEbRSIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_4fb54d948b8a1ce1fb408193",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Tom Thumb Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3300 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://local.tomthumb.com/tx/bedford-3555.html?utm_source=G&utm_medium=Maps&utm_campaign=G+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=812642762322400553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb-pharmacy",
      "poi_latitude": "32.8508253",
      "poi_longitude": "-97.1142482",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-51c7-77de-b940-0376116f076a",
        "storage_key": "property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQ__Y8B_ToYRKdWEaUkWRws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4cad0dafaae6b32203c836de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "609 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-efbe-74b4-a73f-00349753373d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-efbe-74b4-a73f-00349753373d",
        "storage_key": "property/5761334570385408/019f1512-efbe-74b4-a73f-00349753373d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dollartree.com/tx/bedford/609-harwood-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10649453117490668060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "32.8541107",
      "poi_longitude": "-97.1585913",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-254-6050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2f-72cd-b1f6-a970b9c34e2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2f-72cd-b1f6-a970b9c34e2e",
        "storage_key": "property/5761334570385408/019f1510-9f2f-72cd-b1f6-a970b9c34e2e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdUzh85p_ToYRHCI16C91ypM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_b7f7307a589e9772458b7593",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4101 Hwy 121, Bedford, TX 76021, USA",
      "poi_short_description": "Department, grocery and electronics store with self-service checkout stations and a friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-eca4-7249-9657-66dea61f0f5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-eca4-7249-9657-66dea61f0f5e",
        "storage_key": "property/5761334570385408/019f1512-eca4-7249-9657-66dea61f0f5e.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1178-bedford-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5357944823677464364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.8642021",
      "poi_longitude": "-97.1059941",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-571-7929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2f-72cd-b1f6-a970b9c34e2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2f-72cd-b1f6-a970b9c34e2e",
        "storage_key": "property/5761334570385408/019f1510-9f2f-72cd-b1f6-a970b9c34e2e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMVgPu-9_ToYRLC9w9W0-W0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_9b3bd3cecfc1b1a2b8c4a44a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Shady Brook Elementary School",
      "poi_type": "Education",
      "poi_address": "2601 Shady Brook Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-ed54-71bc-bceb-b56883470557.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-ed54-71bc-bceb-b56883470557",
        "storage_key": "property/5761334570385408/019f1512-ed54-71bc-bceb-b56883470557.webp",
        "width": 770,
        "height": 427
      },
      "poi_business_url": "https://www.hebisd.edu/ShadyBrook",
      "poi_directions_map_url": "https://maps.google.com/?cid=13015653926505237914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shady-brook-elementary-school",
      "poi_latitude": "32.8503228",
      "poi_longitude": "-97.1538666",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-399-3150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp40plxR_ToYRmk3DSEnkoLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_d3804d16b38cec1a69081fed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Spring Garden Elementary",
      "poi_type": "Education",
      "poi_address": "2400 Cummings Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-ecfb-706c-ba2e-f83a091be66c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-ecfb-706c-ba2e-f83a091be66c",
        "storage_key": "property/5761334570385408/019f1512-ecfb-706c-ba2e-f83a091be66c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.hebisd.edu/SpringGarden",
      "poi_directions_map_url": "https://maps.google.com/?cid=3471782088197855008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-garden-elementary",
      "poi_latitude": "32.8586449",
      "poi_longitude": "-97.1280455",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-399-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsZmc_Jt_ToYRINeYOGo_LjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_81c1aacdbbef958b1df6cb12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Meadow Creek Elementary",
      "poi_type": "Education",
      "poi_address": "3001 Harwood Rd, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-ee3f-74a8-a24c-00edc4e72b70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-ee3f-74a8-a24c-00edc4e72b70",
        "storage_key": "property/5761334570385408/019f1512-ee3f-74a8-a24c-00edc4e72b70.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hebisd.edu/MeadowCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=14601658701928459716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadow-creek-elementary",
      "poi_latitude": "32.8529872",
      "poi_longitude": "-97.118242",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-399-3620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrfcYF75_ToYRxO3v-zmDo8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_f4ab3a495d6bc5fa9c4e8d77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Harwood Junior High School",
      "poi_type": "Education",
      "poi_address": "3000 Martin Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-ef51-73a9-b0c4-9a1a6b6532d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-ef51-73a9-b0c4-9a1a6b6532d0",
        "storage_key": "property/5761334570385408/019f1512-ef51-73a9-b0c4-9a1a6b6532d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hebisd.edu/harwoodjh",
      "poi_directions_map_url": "https://maps.google.com/?cid=17204898371796786937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harwood-junior-high-school",
      "poi_latitude": "32.85448350000001",
      "poi_longitude": "-97.1158697",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-399-3570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ54GOSr5_ToYR-d6k5-kTxO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a3309d2eb7ba999ce42026d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Bedford Junior High School",
      "poi_type": "Education",
      "poi_address": "325 Carolyn Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f026-751a-8f76-983543e651d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f026-751a-8f76-983543e651d0",
        "storage_key": "property/5761334570385408/019f1512-f026-751a-8f76-983543e651d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hebisd.edu/BedfordJH",
      "poi_directions_map_url": "https://maps.google.com/?cid=14470394027529366915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bedford-junior-high-school",
      "poi_latitude": "32.8552695",
      "poi_longitude": "-97.1629592",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-399-3122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-46_4UZ_ToYRg23SWrMq0cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_dcab6c463bf250c594043122",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "L.D. Bell High School",
      "poi_type": "Education",
      "poi_address": "1601 Brown Trail, Hurst, TX 76054, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f14a-74f4-8022-d94df9222b79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f14a-74f4-8022-d94df9222b79",
        "storage_key": "property/5761334570385408/019f1512-f14a-74f4-8022-d94df9222b79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.hebisd.edu/LDBell",
      "poi_directions_map_url": "https://maps.google.com/?cid=4557705008725231755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ld-bell-high-school",
      "poi_latitude": "32.8428726",
      "poi_longitude": "-97.1605018",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-399-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDZFtWDx_ToYRiwgWxI44QD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_b6fc69ce139bb61476ae9dc8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Trinity High School",
      "poi_type": "Education",
      "poi_address": "500 N Industrial Blvd, Euless, TX 76039, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f467-71ad-aed3-9fcd87a1fd5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f467-71ad-aed3-9fcd87a1fd5e",
        "storage_key": "property/5761334570385408/019f1512-f467-71ad-aed3-9fcd87a1fd5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hebisd.edu/Trinity",
      "poi_directions_map_url": "https://maps.google.com/?cid=2289191850486804822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-high-school",
      "poi_latitude": "32.84298260000001",
      "poi_longitude": "-97.0973708",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-399-3690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtfgmjtB_ToYRVjH8_tvXxB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_6b1ac7e47c94e69fcef0440d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Gene A. Buinger Career & Technical Education Academy",
      "poi_type": "Education",
      "poi_address": "GENE A. BUINGER ACADEMY BLDG E 6017, 1849 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f4cb-7041-ac4a-68f53f64ac35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f4cb-7041-ac4a-68f53f64ac35",
        "storage_key": "property/5761334570385408/019f1512-f4cb-7041-ac4a-68f53f64ac35.webp",
        "width": 1280,
        "height": 873
      },
      "poi_business_url": "https://www.hebisd.edu/BCTEA",
      "poi_directions_map_url": "https://maps.google.com/?cid=7563960283354823195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gene-a-buinger-career--technical-education-academy",
      "poi_latitude": "32.835262",
      "poi_longitude": "-97.136743",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-399-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ6coE6p_ToYRG_qGWM2V-Gg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_91c75e49e0e12eb3fa6e5f03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Primrose School of Bedford",
      "poi_type": "Education",
      "poi_address": "3916 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Day care featuring an age-appropriate curriculum and a safe learning environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f421-7162-8e3e-1b9b57ff61e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f421-7162-8e3e-1b9b57ff61e1",
        "storage_key": "property/5761334570385408/019f1512-f421-7162-8e3e-1b9b57ff61e1.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/bedford/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1085990327275471417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-bedford",
      "poi_latitude": "32.866166",
      "poi_longitude": "-97.130657",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-545-5485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVxa0QoN_ToYROcLD5nI2Eg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_32edc2376b5ef09747d37fc8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Bedford Central KinderCare",
      "poi_type": "Education",
      "poi_address": "2309 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f470-7749-a951-7522f0385ae0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f470-7749-a951-7522f0385ae0",
        "storage_key": "property/5761334570385408/019f1512-f470-7749-a951-7522f0385ae0.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/bedford/tx/000065?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA2NjU1LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=8089694493621498352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bedford-central-kindercare",
      "poi_latitude": "32.8460575",
      "poi_longitude": "-97.1341866",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-571-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtYHMF6d_ToYR8DG-6UdeRHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_5a35fd3e25b5b07f5b7514b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Cinemark North East Mall 18 and XD",
      "poi_type": "Entertainment",
      "poi_address": "1101 Melbourne Rd Ste 6000, Hurst, TX 76053, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f4c4-71b9-bcd6-037afd0404c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f4c4-71b9-bcd6-037afd0404c7",
        "storage_key": "property/5761334570385408/019f1512-f4c4-71b9-bcd6-037afd0404c7.webp",
        "width": 597,
        "height": 365
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-hurst/north-east-mall-18-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MTAtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=7078470057035781729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-north-east-mall-18-and-xd",
      "poi_latitude": "32.8289919",
      "poi_longitude": "-97.2013966",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-591-8540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-5235-761a-a550-28f151f9a60f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-5235-761a-a550-28f151f9a60f",
        "storage_key": "property/5761334570385408/019f1513-5235-761a-a550-28f151f9a60f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJQydlZeB4ToYRYVbbdgPHO2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_347a41660ec552f833e721bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Cinépolis Luxury Cinemas Euless",
      "poi_type": "Entertainment",
      "poi_address": "2601 Brazos Blvd, Euless, TX 76039, USA",
      "poi_short_description": "Movie theater chain, offering state-of-the-art sound & projection technology.",
      "poi_long_description": "Movie theater chain, offering state-of-the-art sound & projection technology.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f65b-74ec-ae3a-d9da70f1110c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f65b-74ec-ae3a-d9da70f1110c",
        "storage_key": "property/5761334570385408/019f1512-f65b-74ec-ae3a-d9da70f1110c.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.cinepolisusa.com/euless/theater-details",
      "poi_directions_map_url": "https://maps.google.com/?cid=12053810578068517441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinpolis-luxury-cinemas-euless",
      "poi_latitude": "32.8748271",
      "poi_longitude": "-97.1047856",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-508-4927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-5235-761a-a550-28f151f9a60f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-5235-761a-a550-28f151f9a60f",
        "storage_key": "property/5761334570385408/019f1513-5235-761a-a550-28f151f9a60f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5WV2dVjVTYYRQbKeX9u8R6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_5e168b2433f9233a7aacd6fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Bedford Ice House",
      "poi_type": "Entertainment",
      "poi_address": "2250 Airport Fwy #300, Bedford, TX 76022, USA",
      "poi_short_description": "Dynamic, unpretentious hangout with cocktails, pub grub, outdoor seating & live music.",
      "poi_long_description": "Dynamic, unpretentious hangout with cocktails, pub grub, outdoor seating & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-027b-704c-ae01-0d51fa8f5bc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-027b-704c-ae01-0d51fa8f5bc1",
        "storage_key": "property/5761334570385408/019f1513-027b-704c-ae01-0d51fa8f5bc1.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://bedfordicehouse.com/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=13427508182967239232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bedford-ice-house",
      "poi_latitude": "32.8352779",
      "poi_longitude": "-97.1313598",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-864-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-51cf-7014-8035-490656681a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-51cf-7014-8035-490656681a83",
        "storage_key": "property/5761334570385408/019f1513-51cf-7014-8035-490656681a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAb0p4qt_ToYRQMJp6IwXWLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_7335bc41b9814d9a3843f83a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Time Rift Arcade - Arcades Near Me | Family Fun!",
      "poi_type": "Entertainment",
      "poi_address": "2113 Harwood Rd Ste 351, Bedford, TX 76021, USA",
      "poi_short_description": "Laid-back haven showcasing pinball, classic and modern games, plus hot dogs and beers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f83a-7001-90c6-0888e41ce1a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f83a-7001-90c6-0888e41ce1a4",
        "storage_key": "property/5761334570385408/019f1512-f83a-7001-90c6-0888e41ce1a4.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://timeriftarcade.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13668174217644010806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "time-rift-arcade---arcades-near-me--family-fun",
      "poi_latitude": "32.8536168",
      "poi_longitude": "-97.1322733",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-646-0771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJie9mp_x_ToYRNu3Sqggcr70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "ec_d87dc22bc3d26efc70ba5595",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Central Arts of Bedford",
      "poi_type": "Entertainment",
      "poi_address": "2816 Central Dr #165, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-f8c0-71b8-aeb1-6f3e5f8f09ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-f8c0-71b8-aeb1-6f3e5f8f09ff",
        "storage_key": "property/5761334570385408/019f1512-f8c0-71b8-aeb1-6f3e5f8f09ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://central-arts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18145426941510341329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-arts-of-bedford",
      "poi_latitude": "32.8516785",
      "poi_longitude": "-97.1295154",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-213-6989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwWqPqJ_ToYR0dKGKqqB0fs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_a35d31eb66d884e9b0059521",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Artisan Center Theater",
      "poi_type": "Entertainment",
      "poi_address": "444 E Pipeline Rd, Hurst, TX 76053, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-fc4b-7563-bda0-3368e73a5f02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-fc4b-7563-bda0-3368e73a5f02",
        "storage_key": "property/5761334570385408/019f1512-fc4b-7563-bda0-3368e73a5f02.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8252038478743517185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "artisan-center-theater",
      "poi_latitude": "32.8220635",
      "poi_longitude": "-97.1616978",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-284-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23Jsu9h_ToYRAbhcdkYhhXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_dadf0fd520dacb2c0195508e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Onstage in Bedford",
      "poi_type": "Entertainment",
      "poi_address": "2400 School Ln, Bedford, TX 76021, USA",
      "poi_short_description": "Cozy, stadium-seating venue featuring a variety of plays, from spooky to comedic.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-fbc6-750e-bc4d-faf98aeb4955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-fbc6-750e-bc4d-faf98aeb4955",
        "storage_key": "property/5761334570385408/019f1512-fbc6-750e-bc4d-faf98aeb4955.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.onstageinbedford.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5997454417977913474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onstage-in-bedford",
      "poi_latitude": "32.8463495",
      "poi_longitude": "-97.1405211",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 325-667-8243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqqZ_ToYRgrArbAQ9O1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_f5645c9e503aa05357a58157",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Generations Park at Boys Ranch",
      "poi_type": "Entertainment",
      "poi_address": "2801 Forest Ridge Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Park with a playground as well as a water area for youngsters and adults.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-029e-74eb-9a56-fb064a22fe2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-029e-74eb-9a56-fb064a22fe2a",
        "storage_key": "property/5761334570385408/019f1513-029e-74eb-9a56-fb064a22fe2a.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://bedfordtx.gov/454/Generations-Park-at-Boys-Ranch",
      "poi_directions_map_url": "https://maps.google.com/?cid=15271839672042243355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "generations-park-at-boys-ranch",
      "poi_latitude": "32.8500342",
      "poi_longitude": "-97.1449222",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e6f-7456-a0ab-c492303c8511",
        "storage_key": "property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTQT6fB_ToYRG8XLnkR58NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0f2071ed6154b48d51464c92",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Toadies Bar and Grill",
      "poi_type": "Entertainment",
      "poi_address": "1705 Airport Fwy, Bedford, TX 76021, USA",
      "poi_short_description": "Lively watering hole with patio seating & American chow, including sandwiches & fried fare.",
      "poi_long_description": "Lively watering hole with patio seating & American chow, including sandwiches & fried fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-fca0-74cb-9176-f7f0b7b86fcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-fca0-74cb-9176-f7f0b7b86fcc",
        "storage_key": "property/5761334570385408/019f1512-fca0-74cb-9176-f7f0b7b86fcc.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://toadiesbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13155222745530500749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toadies-bar-and-grill",
      "poi_latitude": "32.837662",
      "poi_longitude": "-97.1398241",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-283-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-51cf-7014-8035-490656681a83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-51cf-7014-8035-490656681a83",
        "storage_key": "property/5761334570385408/019f1513-51cf-7014-8035-490656681a83.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmZCzwgZ_ToYRjQZ8QGO9kLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_65fe934aa8d1fffabd058825",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "LEGOLAND® Discovery Center Dallas/Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-fca0-74cb-9176-f215a2219700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-fca0-74cb-9176-f215a2219700",
        "storage_key": "property/5761334570385408/019f1512-fca0-74cb-9176-f215a2219700.webp",
        "width": 701,
        "height": 467
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/dallas-fw/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=8213318445731368129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-dallasfort-worth",
      "poi_latitude": "32.9666453",
      "poi_longitude": "-97.0434661",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwU71w4YrTIYRwUz7QJyR-3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_4beeb25906098df6e01000ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hurst-Euless-Bedford",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 Hospital Pkwy, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-fcb0-721a-8bff-ca018e390735.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-fcb0-721a-8bff-ca018e390735",
        "storage_key": "property/5761334570385408/019f1512-fcb0-721a-8bff-ca018e390735.webp",
        "width": 1279,
        "height": 719
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-heb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046041147271700356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hurst-euless-bedford",
      "poi_latitude": "32.8349711",
      "poi_longitude": "-97.1244698",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-848-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e69-7683-839b-a51eba40b642.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e69-7683-839b-a51eba40b642",
        "storage_key": "property/5761334570385408/019f1510-9e69-7683-839b-a51eba40b642.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-xkb7J_ToYRhF9OL8tHqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_16ebf0ed678d334e1fc77349",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "WithCare Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Airport Fwy #550, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-0299-727a-9c09-8eec45706853.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-0299-727a-9c09-8eec45706853",
        "storage_key": "property/5761334570385408/019f1513-0299-727a-9c09-8eec45706853.webp",
        "width": 1104,
        "height": 1280
      },
      "poi_business_url": "https://www.withcareclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=885425838882029726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "withcare-clinic",
      "poi_latitude": "32.8342759",
      "poi_longitude": "-97.1325215",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-949-6080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7Jwb_V_ToYRngCE-RuqSQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_275eab9fae05703b126c741a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "WithCare Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 Airport Fwy #550, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-0542-7361-ab30-2b38ccc48a68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-0542-7361-ab30-2b38ccc48a68",
        "storage_key": "property/5761334570385408/019f1513-0542-7361-ab30-2b38ccc48a68.webp",
        "width": 1104,
        "height": 1280
      },
      "poi_business_url": "https://www.withcareclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=885425838882029726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "withcare-clinic",
      "poi_latitude": "32.8342759",
      "poi_longitude": "-97.1325215",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-949-6080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7Jwb_V_ToYRngCE-RuqSQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_c2781206c458e6d6bf6093f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2900 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e7e3-75dc-b116-52c4e9088310.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e7e3-75dc-b116-52c4e9088310",
        "storage_key": "property/5761334570385408/019f1512-e7e3-75dc-b116-52c4e9088310.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bedford-tx-pharmacies/2900-central-dr-bedford-tx-76021/storeid=7449?WT.mc_id=LS_GOOGLE_RX_7449",
      "poi_directions_map_url": "https://maps.google.com/?cid=14103719006248815440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8524047",
      "poi_longitude": "-97.1315133",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-571-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-51c7-77de-b940-0376116f076a",
        "storage_key": "property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNUWB5aF_ToYRUMtiI7Z5usM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a51a31632dcfa4ce4f620526",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2253 Central Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e98f-707c-b295-b5640560583d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e98f-707c-b295-b5640560583d",
        "storage_key": "property/5761334570385408/019f1512-e98f-707c-b295-b5640560583d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2253+central+dr-bedford-tx-76021/id=3881",
      "poi_directions_map_url": "https://maps.google.com/?cid=13275929325986654885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.844242",
      "poi_longitude": "-97.1341074",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-868-9202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJif_Xpad_ToYRpSqgEmKTPbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_54236fb0bb042cc86bf5b6f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Health and Wellness",
      "poi_address": "2108 Bedford Rd, Bedford, TX 76021, USA",
      "poi_short_description": "Chain supermarket offering groceries, electronics, furniture, appliances, and other merchandise, plus check cashing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-eb6b-7732-976f-35699f759331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-eb6b-7732-976f-35699f759331",
        "storage_key": "property/5761334570385408/019f1512-eb6b-7732-976f-35699f759331.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/3392-bedford-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9243868335846487013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.8436418",
      "poi_longitude": "-97.1322989",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-283-9841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9eb3-73b5-a360-a03507e5049e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9eb3-73b5-a360-a03507e5049e",
        "storage_key": "property/5761334570385408/019f1510-9eb3-73b5-a360-a03507e5049e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5OJCqd_ToYR5XOcfEbRSIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_8b41e0857f27421fe30529f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Trail Creek Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 Tibbets Dr #200, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-e4bc-71a7-ba65-ef5278e4fbb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-e4bc-71a7-ba65-ef5278e4fbb7",
        "storage_key": "property/5761334570385408/019f1512-e4bc-71a7-ba65-ef5278e4fbb7.webp",
        "width": 960,
        "height": 435
      },
      "poi_business_url": "https://www.trailcreekpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5218543994494075815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trail-creek-pharmacy",
      "poi_latitude": "32.83247",
      "poi_longitude": "-97.122741",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-684-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-51c7-77de-b940-0376116f076a",
        "storage_key": "property/5761334570385408/019f1513-51c7-77de-b940-0376116f076a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLTA6XbN_ToYRp0ORLB3-a0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c2831fee6206e0f12dedc380",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "The Bedford Center YMCA | YMCA of Fort Worth",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 Forest Ridge Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-0c2d-74ca-9483-75d32f9c12ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-0c2d-74ca-9483-75d32f9c12ff",
        "storage_key": "property/5761334570385408/019f1513-0c2d-74ca-9483-75d32f9c12ff.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://ymcafw.org/locations/bedford-center-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6890165811885098163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bedford-center-ymca--ymca-of-fort-worth",
      "poi_latitude": "32.8494437",
      "poi_longitude": "-97.1482285",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-725-8439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ26N3Vpl_ToYRs8Tz3EzJnl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_cc51fc81e9b8f32c96d1b825",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Texas Health Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1616 Hospital Pkwy, Bedford, TX 76022, USA",
      "poi_short_description": "Clean, welcoming fitness center featuring multiple exercise machines for members' use.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-0b0f-722f-9535-a19773d7fbf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-0b0f-722f-9535-a19773d7fbf2",
        "storage_key": "property/5761334570385408/019f1513-0b0f-722f-9535-a19773d7fbf2.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.texashealth.org/heb/services/fitness-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14991773332153100828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-fitness-center",
      "poi_latitude": "32.8361183",
      "poi_longitude": "-97.1248899",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-848-5640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUAGh61_ToYRHOoocGp6DdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_cc122f1ae090d3a09683040a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "IV Lagree",
      "poi_type": "Health and Wellness",
      "poi_address": "4153 Bedford Rd Ste 100, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-0733-738f-96c1-6b71081c4343.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-0733-738f-96c1-6b71081c4343",
        "storage_key": "property/5761334570385408/019f1513-0733-738f-96c1-6b71081c4343.webp",
        "width": 1148,
        "height": 1192
      },
      "poi_business_url": "https://integratedvitalitydfw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15041062892106671008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iv-lagree",
      "poi_latitude": "32.8448316",
      "poi_longitude": "-97.102084",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 682-471-3607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSnNRsl_ToYRoONTaAKXvNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_9bd2128fff356020b234f99a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Central Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-08b2-7770-ad61-2475fde1a20b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-08b2-7770-ad61-2475fde1a20b",
        "storage_key": "property/5761334570385408/019f1513-08b2-7770-ad61-2475fde1a20b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/797/Central-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16946138223623832225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-park",
      "poi_latitude": "32.8308545",
      "poi_longitude": "-97.1341987",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e6f-7456-a0ab-c492303c8511",
        "storage_key": "property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_S4KBHl_ToYRoYLEDe7GLOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ba09fda36c03adc3cd9f0ac2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Generations Park at Boys Ranch",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2801 Forest Ridge Dr, Bedford, TX 76021, USA",
      "poi_short_description": "Park with a playground as well as a water area for youngsters and adults.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-0b10-722c-a4d2-6f4fc9c265f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-0b10-722c-a4d2-6f4fc9c265f0",
        "storage_key": "property/5761334570385408/019f1513-0b10-722c-a4d2-6f4fc9c265f0.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://bedfordtx.gov/454/Generations-Park-at-Boys-Ranch",
      "poi_directions_map_url": "https://maps.google.com/?cid=15271839672042243355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "generations-park-at-boys-ranch",
      "poi_latitude": "32.8500342",
      "poi_longitude": "-97.1449222",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e6f-7456-a0ab-c492303c8511",
        "storage_key": "property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTQT6fB_ToYRG8XLnkR58NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_93ab71bd9f7e8a5ec244a39a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Old Bedford School",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2400 School Ln, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-07f3-73e6-a829-70140022e0e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-07f3-73e6-a829-70140022e0e4",
        "storage_key": "property/5761334570385408/019f1513-07f3-73e6-a829-70140022e0e4.webp",
        "width": 1280,
        "height": 842
      },
      "poi_business_url": "http://www.oldbedfordschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7824978194468413087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-bedford-school",
      "poi_latitude": "32.84638170000001",
      "poi_longitude": "-97.1404787",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-952-2290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQajTQwl_ToYRn553mDXol2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_caf3ff459a329d7bc765612e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Stormie Jones Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2700 Brasher Ln, Bedford, TX 76021, USA",
      "poi_short_description": "Cozy park featuring a playground, soccer fields and various benches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-0fc4-7025-af97-500828b94925.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-0fc4-7025-af97-500828b94925",
        "storage_key": "property/5761334570385408/019f1513-0fc4-7025-af97-500828b94925.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bedfordtx.gov/parks/#stormie",
      "poi_directions_map_url": "https://maps.google.com/?cid=12476369858625914344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stormie-jones-park",
      "poi_latitude": "32.8479816",
      "poi_longitude": "-97.1025522",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e6f-7456-a0ab-c492303c8511",
        "storage_key": "property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf1bvQdt_ToYR6MXJpUj4JK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_032622f0551fab9ae3685234",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Harris Ryals Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-12d6-732d-98b1-9818669aa612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-12d6-732d-98b1-9818669aa612",
        "storage_key": "property/5761334570385408/019f1513-12d6-732d-98b1-9818669aa612.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/800/Harris-Ryals-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10707763129201414480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-ryals-park",
      "poi_latitude": "32.8589854",
      "poi_longitude": "-97.1252968",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e6f-7456-a0ab-c492303c8511",
        "storage_key": "property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBy9UIzV_ToYRUFETd9WdmZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e751053829488897b0c1529b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Meadow Park Athletic Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3200 Meadow Park Dr, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-139f-71dc-86c8-bad7cabd3a13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-139f-71dc-86c8-bad7cabd3a13",
        "storage_key": "property/5761334570385408/019f1513-139f-71dc-86c8-bad7cabd3a13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/801/Meadow-Park-Athletic-Complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=4106394932829973679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadow-park-athletic-complex",
      "poi_latitude": "32.85446160000001",
      "poi_longitude": "-97.1348766",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2BMaXV_ToYRr2zLTm_Y_Dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_57e7e508f5b6d6f232afa0ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "East End Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3700 Hastings Pl, Bedford, TX 76021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-1344-77f4-9d67-7e5f91290cf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-1344-77f4-9d67-7e5f91290cf1",
        "storage_key": "property/5761334570385408/019f1513-1344-77f4-9d67-7e5f91290cf1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bedfordtx.gov/799/East-End-Trail-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5941866782082827483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-end-trail-park",
      "poi_latitude": "32.8620963",
      "poi_longitude": "-97.1110256",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e6f-7456-a0ab-c492303c8511",
        "storage_key": "property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9L6iUB_ToYR24S9YFvAdVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_63bbe765bb62f0090e34a5f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Brook Hollow Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "752 Rankin Dr, Bedford, TX 76022, USA",
      "poi_short_description": "Family-friendly play space with a climbing area and slides, along with a paved walking trail.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-1790-7759-b5a8-cbcd0ee2fb06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-1790-7759-b5a8-cbcd0ee2fb06",
        "storage_key": "property/5761334570385408/019f1513-1790-7759-b5a8-cbcd0ee2fb06.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://bedfordtx.gov/795/Brook-Hollow-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=967710100018973644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brook-hollow-park",
      "poi_latitude": "32.8247687",
      "poi_longitude": "-97.1513298",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e6f-7456-a0ab-c492303c8511",
        "storage_key": "property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_qT9-N-ToYRzEswdTX_bQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_bff05264b10b3982cb4cddf1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Carousel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Carousel Park, 1100 Simpson Terrace, Bedford, TX 76021, USA",
      "poi_short_description": "This community park spanning one acre offers play structures & plenty of tree-shaded space.",
      "poi_long_description": "This community park spanning one acre offers play structures & plenty of tree-shaded space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-18b9-7317-adff-0b7ad335d52b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-18b9-7317-adff-0b7ad335d52b",
        "storage_key": "property/5761334570385408/019f1513-18b9-7317-adff-0b7ad335d52b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bedfordtx.gov/796/Carousel-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9869507532389123190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carousel-park",
      "poi_latitude": "32.8611256",
      "poi_longitude": "-97.1523189",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-952-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e6f-7456-a0ab-c492303c8511",
        "storage_key": "property/5761334570385408/019f1510-9e6f-7456-a0ab-c492303c8511.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3MkLm9_ToYRdoQYUM-I94g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_683fe9b4d1a8976fd42d0d5a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Pennington Field",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1501 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "Football, soccer, and gymnastics facility also hosting band competitions and community events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-15a0-77fb-a0e8-0f14adf214d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-15a0-77fb-a0e8-0f14adf214d5",
        "storage_key": "property/5761334570385408/019f1513-15a0-77fb-a0e8-0f14adf214d5.webp",
        "width": 760,
        "height": 480
      },
      "poi_business_url": "https://www.hebisd.edu/departments/pennington-field/pennington-field",
      "poi_directions_map_url": "https://maps.google.com/?cid=13627200424747001182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennington-field",
      "poi_latitude": "32.8326367",
      "poi_longitude": "-97.1362665",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-399-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-528e-777c-b7b6-9ff6f76b6bc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-528e-777c-b7b6-9ff6f76b6bc5",
        "storage_key": "property/5761334570385408/019f1513-528e-777c-b7b6-9ff6f76b6bc5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD6crL1V-ToYRXuUYGJaKHb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_f85219edbcbfe2396cce5bdb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Bell",
      "poi_type": "Transportation & Transit",
      "poi_address": "3232 Bell Flight Blvd, Hurst, TX 76053, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-84e6-7520-9258-d79aed24e2bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-84e6-7520-9258-d79aed24e2bd",
        "storage_key": "property/5761334570385408/019f1510-84e6-7520-9258-d79aed24e2bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trinityrailwayexpress.org/station/bell-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11367673502258708933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell",
      "poi_latitude": "32.8046324",
      "poi_longitude": "-97.1551139",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-a30b-7118-8236-783921923a2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-a30b-7118-8236-783921923a2b",
        "storage_key": "property/5761334570385408/019f1510-a30b-7118-8236-783921923a2b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSKsN5V-ToYRxUHAYNIWwp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_59efe7f505544a8934e8b85e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "CentrePort/DFW Airport Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "14470 Statler Blvd, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-1979-7109-9489-ca9271bee1f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-1979-7109-9489-ca9271bee1f9",
        "storage_key": "property/5761334570385408/019f1513-1979-7109-9489-ca9271bee1f9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/guide/transit-and-use/rail/rail-station-detail/centreport-dfw-airport-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619245285415004907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centreportdfw-airport-station",
      "poi_latitude": "32.8170102",
      "poi_longitude": "-97.0528488",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-52f2-740e-989b-0a140fe39b11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-52f2-740e-989b-0a140fe39b11",
        "storage_key": "property/5761334570385408/019f1513-52f2-740e-989b-0a140fe39b11.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7AqJ-KAToYR6ypjCQK3eBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_e2459f3f1a50f746065b179c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Fort Worth Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-1a3c-77aa-abb3-ad30e66d57ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-1a3c-77aa-abb3-ad30e66d57ea",
        "storage_key": "property/5761334570385408/019f1513-1a3c-77aa-abb3-ad30e66d57ea.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666534907176730361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-central",
      "poi_latitude": "32.7526669",
      "poi_longitude": "-97.3264798",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 22 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-a30b-7118-8236-783921923a2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-a30b-7118-8236-783921923a2b",
        "storage_key": "property/5761334570385408/019f1510-a30b-7118-8236-783921923a2b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbEKLz5xToYR-b7q6jFtS-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_39833a24fb9dc151d6c445b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Fort Worth T&p",
      "poi_type": "Transportation & Transit",
      "poi_address": "221 W Lancaster Ave, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-1b25-741b-a340-45da59d6fbef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-1b25-741b-a340-45da59d6fbef",
        "storage_key": "property/5761334570385408/019f1513-1b25-741b-a340-45da59d6fbef.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/fort-worth-tp-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2586634399591785905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-tp",
      "poi_latitude": "32.7453226",
      "poi_longitude": "-97.3279067",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 40 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-a30b-7118-8236-783921923a2b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-a30b-7118-8236-783921923a2b",
        "storage_key": "property/5761334570385408/019f1510-a30b-7118-8236-783921923a2b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TtRaxNxToYRsWV5J0iS5SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_e231407d155dff456a053281",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "North Richland Hills/Iron Horse Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-23a7-755f-9eb7-b89643c7b160.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-23a7-755f-9eb7-b89643c7b160",
        "storage_key": "property/5761334570385408/019f1513-23a7-755f-9eb7-b89643c7b160.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5631713715274185447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hillsiron-horse-station",
      "poi_latitude": "32.8447652",
      "poi_longitude": "-97.2494671",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWX3dj54ToYR5_qcM8ndJ04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "ec_407d9b773ace4ad4a450d660",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "North Richland Hills/Smithfield TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "6420 Smithfield Rd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-20f2-73cf-adfa-116cd626c584.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-20f2-73cf-adfa-116cd626c584",
        "storage_key": "property/5761334570385408/019f1513-20f2-73cf-adfa-116cd626c584.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/north-richland-hills-smithfield-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17453827278972292890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hillssmithfield-texrail-station",
      "poi_latitude": "32.8640386",
      "poi_longitude": "-97.2116058",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQM5-j55ToYRGo8qlm9zOPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_647b4cff00a33aff19c2af41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Mercantile Center Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "4233 N Beach St, Fort Worth, TX 76137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-2f54-74e7-a4cd-614d891450e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-2f54-74e7-a4cd-614d891450e9",
        "storage_key": "property/5761334570385408/019f1513-2f54-74e7-a4cd-614d891450e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8576246469015309317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercantile-center-station",
      "poi_latitude": "32.8195149",
      "poi_longitude": "-97.2933422",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSZcvQl3ToYRBQzbg7nyBHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_0bdeaa4ef6f585acaeda0ea0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Grapevine/Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-330e-75bd-b717-165a5baf0e82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-330e-75bd-b717-165a5baf0e82",
        "storage_key": "property/5761334570385408/019f1513-330e-75bd-b717-165a5baf0e82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ridetrinitymetro.org/texrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18405502107178557258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grapevinemain-street-station",
      "poi_latitude": "32.9338028",
      "poi_longitude": "-97.0772663",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEz-M8e0rTIYRSt8UY6Z6bf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_351139a6ad8bc34e70609ed8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-7f86-7597-9b71-ab8e523d41dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-7f86-7597-9b71-ab8e523d41dc",
        "storage_key": "property/5761334570385408/019f1510-7f86-7597-9b71-ab8e523d41dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9ecc-71bc-b9a8-2c1442f6c57d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9ecc-71bc-b9a8-2c1442f6c57d",
        "storage_key": "property/5761334570385408/019f1510-9ecc-71bc-b9a8-2c1442f6c57d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_9455edf1410132affecb1609",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "DFW Airport North TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1867 E Dallas Rd, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-297e-709e-87f7-68afe133e7d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-297e-709e-87f7-68afe133e7d0",
        "storage_key": "property/5761334570385408/019f1513-297e-709e-87f7-68afe133e7d0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/dfw-airport-north-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6621859291758648515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-north-texrail-station",
      "poi_latitude": "32.9337128",
      "poi_longitude": "-97.0541165",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOV8hQtwrTIYRw9zkFfGR5Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_2a551cc12c9b6cf2cf8c29a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hurst-Euless-Bedford",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Hospital Pkwy, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1512-fcb0-721a-8bff-ca018e390735.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-fcb0-721a-8bff-ca018e390735",
        "storage_key": "property/5761334570385408/019f1512-fcb0-721a-8bff-ca018e390735.webp",
        "width": 1279,
        "height": 719
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-heb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046041147271700356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hurst-euless-bedford",
      "poi_latitude": "32.8349711",
      "poi_longitude": "-97.1244698",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-848-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e69-7683-839b-a51eba40b642.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e69-7683-839b-a51eba40b642",
        "storage_key": "property/5761334570385408/019f1510-9e69-7683-839b-a51eba40b642.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-xkb7J_ToYRhF9OL8tHqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_12ad9ba25e8c290012f00941",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "HEB ISD Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1849 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-2be0-767f-9cb5-b014a186ed82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-2be0-767f-9cb5-b014a186ed82",
        "storage_key": "property/5761334570385408/019f1513-2be0-767f-9cb5-b014a186ed82.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hebisd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11828638531553007483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heb-isd-administration-building",
      "poi_latitude": "32.8352588",
      "poi_longitude": "-97.1342016",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-283-4461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ6coE6p_ToYRexe32RLEJ6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_d9e78faa750f4a96b2e3452e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Tarrant County College - Northeast Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "828 W Harwood Rd, Hurst, TX 76054, USA",
      "poi_short_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_long_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-5ca9-7419-86c1-31d4874b971a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-5ca9-7419-86c1-31d4874b971a",
        "storage_key": "property/5761334570385408/019f1510-5ca9-7419-86c1-31d4874b971a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tccd.edu/locations/northeast-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6601226914742018412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarrant-county-college---northeast-campus",
      "poi_latitude": "32.84692560000001",
      "poi_longitude": "-97.1917037",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-515-8223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e5a-77fd-9483-ccd8bb7b6b47",
        "storage_key": "property/5761334570385408/019f1510-9e5a-77fd-9483-ccd8bb7b6b47.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-TYe8h4ToYRbCHydudEnFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_e38f1c83fcf1d967a5e12596",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Bell",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3255 Bell Flight Blvd, Fort Worth, TX 76118, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-3482-708b-a79e-c18f515a3a10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-3482-708b-a79e-c18f515a3a10",
        "storage_key": "property/5761334570385408/019f1513-3482-708b-a79e-c18f515a3a10.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bellflight.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2708728753638745052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell",
      "poi_latitude": "32.8080827",
      "poi_longitude": "-97.1564018",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-280-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fcbcMB-ToYR3COGMXNWlyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_c71acb87012b483197932046",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "United States Air Force Plant 4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lockheed Blvd, Fort Worth, TX 76108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cumulis.epa.gov/supercpad/cursites/csitinfo.cfm?id=0603610",
      "poi_directions_map_url": "https://maps.google.com/?cid=16010628610778343053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-plant-4",
      "poi_latitude": "32.7711827",
      "poi_longitude": "-97.4502721",
      "poi_miles_from_property": "24.8 mi",
      "poi_walking_minutes": "9 hours 16 mins",
      "poi_biking_minutes": "2 hours 26 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSVNmIQLToYRjSYmwOQtMd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_3724686166c572a0c8064660",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "BNSF Railway Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2650 Lou Menk Dr, Fort Worth, TX 76131, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-3ac8-774a-af1f-0fc4f939d7a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-3ac8-774a-af1f-0fc4f939d7a1",
        "storage_key": "property/5761334570385408/019f1513-3ac8-774a-af1f-0fc4f939d7a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bnsf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6950109642693621881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bnsf-railway-corporate",
      "poi_latitude": "32.8636589",
      "poi_longitude": "-97.328125",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-832-5452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqjm_QIYReTjFkuW_c2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_9817a239106665987f516ca4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "American Airlines - Skyview 7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "RWFJ+R6, Transformation Way, Fort Worth, TX 76155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-2fd7-7469-ab1e-f1dbc5af77aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-2fd7-7469-ab1e-f1dbc5af77aa",
        "storage_key": "property/5761334570385408/019f1513-2fd7-7469-ab1e-f1dbc5af77aa.webp",
        "width": 1280,
        "height": 450
      },
      "poi_business_url": "http://www.aa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15492633573707074314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-airlines---skyview-7",
      "poi_latitude": "32.8291621",
      "poi_longitude": "-97.0659943",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 682-278-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9f2a-73d6-8da6-6d3e319032e8",
        "storage_key": "property/5761334570385408/019f1510-9f2a-73d6-8da6-6d3e319032e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaLL45iBToYRCssZ3CbkANc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_29fb7cbecd8670fcfd64b5af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-7f86-7597-9b71-ab8e523d41dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1510-7f86-7597-9b71-ab8e523d41dc",
        "storage_key": "property/5761334570385408/019f1510-7f86-7597-9b71-ab8e523d41dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9ecc-71bc-b9a8-2c1442f6c57d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9ecc-71bc-b9a8-2c1442f6c57d",
        "storage_key": "property/5761334570385408/019f1510-9ecc-71bc-b9a8-2c1442f6c57d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_602a39362d00afbf47075a26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Medical City Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "900 8th Ave, Fort Worth, TX 76104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-3355-7328-8184-c7a851a454d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1513-3355-7328-8184-c7a851a454d5",
        "storage_key": "property/5761334570385408/019f1513-3355-7328-8184-c7a851a454d5.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-fort-worth-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=524071590630840069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-fort-worth",
      "poi_latitude": "32.7358664",
      "poi_longitude": "-97.3452877",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 817-336-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1510-9e69-7683-839b-a51eba40b642.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1510-9e69-7683-839b-a51eba40b642",
        "storage_key": "property/5761334570385408/019f1510-9e69-7683-839b-a51eba40b642.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2QNkntxToYRBddsxFXgRQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_524982c5b44926ebecc7fab3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "poi_name": "Tarrant County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 E Weatherford St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tarrantcountytx.gov/en/facilities-management/building-services/downtown-buildings/administration-building.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13569461432259023583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarrant-county-administration-building",
      "poi_latitude": "32.7568257",
      "poi_longitude": "-97.3321576",
      "poi_miles_from_property": "14.3 mi",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 817-884-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f1513-523f-75d8-b569-3f7f3485b3d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1513-523f-75d8-b569-3f7f3485b3d6",
        "storage_key": "property/5761334570385408/019f1513-523f-75d8-b569-3f7f3485b3d6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdTwXgBxToYR35IpT0dpULw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_0e27f4b2-711f-439f-a763-ee25ef362d49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_66f7bc03-eab5-4472-80c8-04422ecf62d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ea7d8f3a-d2aa-427e-b7a0-9ec6f6adc2ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8ba3cefe-8e27-464a-9abc-a8cb0329c6c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_d305cfac-3e75-44db-8611-d90777621fc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_c43a8319-83f0-4dc5-a316-63588f910491",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a1290b62-6f5b-4561-afed-0b0bf17bf392",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_da76a6a3-82dd-4edb-92af-22b3c996bfbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "rating": "5.0",
      "name": "Gabriel Juarez",
      "text": "Moved in several months ago and I'm comfortable here. The apartments are nice inside and out. The neighbors are friendly, it's clean, quiet and the community around us is nice. Kim was helpful, knowledgeable and kind. I told her I was under a time constraint, and she was able to complete the leasing process the same day I submitted my application.\nThe reason I decided to write this review today is because of an email I received from Belinda. She asked how everything was going and if there was anything they could help with. Seems like a small gesture, but I've never received such a message from any place I've ever lived. I appreciated it. Any management of other properties, I've dealt with in the past ignored messages, phone calls and gave me a feeling of being a burden. In turn never feeling comfortable.\nPoint is the vibe here is a really good one.",
      "date": "2026-01-08",
      "title": ""
    },
    {
      "id": "custom_0a502d23-afad-4a10-8a8f-6ec60951df78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "rating": "5.0",
      "name": "Roderick Mayfield",
      "text": "I don't like to boast much, but Kimberly has been everything that she said she would be from the moment we met to signing my lease. I appreciate this home and the environment is great. I highly recommend them for any housing needs in the area. I love my new home!",
      "date": "2026-03-20",
      "title": ""
    },
    {
      "id": "custom_8c089eff-a64d-45cf-8f3d-5224849a4038",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "rating": "5.0",
      "name": "Don Hanson",
      "text": "I've lived here for at least 5 years.  It's quiet.  I never hear my neighbors.  The property is well kept.  The management sends regular updates if there are any special service repairs, outages or severe weather announcements.  Management is always quick to respond to any requests or questions I might have.  I really appreciate management's sincere concerns to make sure my expectations are met. In the time I've lived here, I have had no problems or complaints whatsoever.",
      "date": "2026-04-16",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_ff81aa2a6010c4f61d59344e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f14c4-bead-74ce-b823-50e48a991b46.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-bead-74ce-b823-50e48a991b46",
        "storage_key": "property/5761334570385408/019f14c4-bead-74ce-b823-50e48a991b46.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Canopy On Central",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/Q3akRSIROQw"
    }
  ],
  "faqs": [
    {
      "id": "custom_f798ab01-1ff7-46b9-b8c1-f11b527536b7",
      "question": "Is Canopy on Central pet-friendly?",
      "answer": "Yes. Canopy on Central welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (817) 858-5536 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_63b4f32d-d544-4d3c-99ff-2794b45443a5",
      "question": "How can I schedule a tour at Canopy on Central?",
      "answer": "You can schedule a tour of Canopy on Central online through our Schedule a Tour page, or call the leasing office at (817) 858-5536. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_729a8f72-3b7b-4d26-8bc9-2f9341497c7e",
      "question": "What are the leasing office hours at Canopy on Central?",
      "answer": "The Canopy on Central leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (817) 858-5536 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_75830cd2-8e09-49a9-a21a-aeac12215eb4",
      "question": "What floor plans are available at Canopy on Central?",
      "answer": "Canopy on Central offers 1- and 2-bedroom apartment homes ranging from approximately 520 to 995 square feet, across 12 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_91dd1faa-663c-4968-a97e-bb743c0174f5",
      "question": "What amenities does Canopy on Central have?",
      "answer": "Canopy on Central offers a range of community and in-home amenities. Community amenities include: Covered Parking, Pool, Resident Clubhouse, Fitness Center, Online Resident Services, American Landmark 360, and Laundry Rooms. In-home features include: built-in bookcase, double vanity, fire, hard floors, sink, townhomes, views, w&d connections, walk-in closet, outside space, and select homes. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_54fd54ae-ca7f-4382-b2a3-beecf2554d48",
      "question": "Where is Canopy on Central located?",
      "answer": "Canopy on Central is located at 2700 Central Dr, Bedford TX 76021. Nearby you'll find dining at Bleu Bear Sushi, Bedford, TX, shopping at Trail Creek Pharmacy, and green space at Central Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_ff7f4ea7-3dfa-493a-8563-205f29e3b339",
      "question": "How do I apply to live at Canopy on Central?",
      "answer": "You can apply to live at Canopy on Central online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (817) 858-5536 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_2fc075a6-ee4a-49d2-804a-b7b7a7f4658d",
      "question": "What do I need to apply at Canopy on Central?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Canopy on Central leasing team at (817) 858-5536 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_de9650a7-0fd1-49a8-b3ea-1bf8a5173444",
      "question": "What is the Landmark 360 program at Canopy on Central?",
      "answer": "Canopy on Central participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (817) 858-5536 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_4baa35cc-4fb2-4424-a089-65ae66c71399",
      "question": "Does Canopy on Central have a pool?",
      "answer": "Yes. Canopy on Central has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_2358f099-d962-4262-9e4e-26516ab3e143",
      "question": "Does Canopy on Central have a fitness center?",
      "answer": "Yes. Canopy on Central has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_e99efa2f-ec0a-470b-bfd2-ec9b6d2721ed",
      "question": "Does Canopy on Central offer virtual tours?",
      "answer": "Yes. Canopy on Central offers virtual tours of Canopy On Central. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_fe571025-1409-4464-ba97-2f312e9df4be",
      "question": "What do residents say about living at Canopy on Central?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Canopy on Central. One resident wrote: *\"Moved in several months ago and I'm comfortable here. The apartments are nice inside and out. The neighbors are friendly, it's clean, quiet and the community around us is nice. Kim was helpful, knowledgeable and kind.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_79dd980c-85d2-4fcf-a3ca-0494e76d4e06",
      "question": "When was Canopy on Central built?",
      "answer": "Canopy on Central was built in 1982 and renovated in 2020. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_079a50bb-e0f2-44e4-8d78-09817964bfc8",
      "question": "What is the pet fee at Canopy on Central?",
      "answer": "Pets at Canopy on Central: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (817) 858-5536 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_c113564b-4f63-40dd-8959-1c11a90d07cf",
      "question": "What features are included in the apartments at Canopy on Central?",
      "answer": "Apartment homes at Canopy on Central include built-in bookcase, double vanity, fire, hard floors, sink, townhomes, views, w&d connections, walk-in closet, outside space, and select homes. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_c1f4711e-12cc-4077-ba35-91223effbaee",
      "question": "What restaurants and shops are near Canopy on Central?",
      "answer": "Nearby restaurants and shops include Bleu Bear Sushi, Bedford, TX, Twisted Root Burger Co., Danny's Celtic Pub, and Coffee Tea & Books. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-3e2a-739c-9cdb-b7a09c53dc6e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "canopy-on-central",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408"
    },
    {
      "lead_collector_id": "0198aa45-3e8e-74c1-aecf-69d407b1baa2",
      "lead_source": "FACEBOOK_ADS",
      "name": "canopy-on-central",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408"
    },
    {
      "lead_collector_id": "0198aa45-3ef1-77ea-9652-3d1671c1af0a",
      "lead_source": "LANDING_PAGE",
      "name": "canopy-on-central",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-bedford-tx",
      "search_query": "One Bedroom Apartments For Rent In Bedford TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Bedford TX",
      "h2_subtitle": "Discover your ideal living space at Canopy on Central. Our one-bedroom apartments offer comfort and convenience in a prime Bedford location.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | One Bedroom Apartments For Rent In Bedford TX",
      "seo_description": "Find your ideal home at Canopy on Central. Explore our one bedroom apartments for rent in Bedford TX, featuring premium amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-bedford-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Bedford TX",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Bedford TX",
      "h2_subtitle": "Experience the best of Bedford living at Canopy on Central. Our two-bedroom apartments offer spacious layouts and premium amenities for your comfort.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Two Bedrooms Apartments For Rent In Bedford TX",
      "seo_description": "Discover spacious living at Canopy on Central. Explore our two bedrooms apartments for rent in Bedford TX, featuring top-notch amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-resort-inspired-pools",
      "search_query": "Apartments For Rent Near Me with 5 Resort-Inspired Swimming Pools w/ Sundecks",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with 5 Resort-Inspired Swimming Pools w/ Sundecks",
      "h2_subtitle": "Discover luxury living at Canopy on Central. Enjoy our five resort-inspired swimming pools with sundecks and a host of other premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-inspired swimming pools with sundecks. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with 5 Resort-Inspired Swimming Pools w/ Sundecks",
      "seo_description": "Find luxury living at Canopy on Central. Explore apartments for rent near me with 5 resort-inspired swimming pools w/ sundecks and premium amenities in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-24hr-fitness-cardio-center",
      "search_query": "Apartments For Rent Near Me with 24-Hour Fitness & Cardio Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with 24-Hour Fitness & Cardio Center",
      "h2_subtitle": "Elevate your lifestyle at Canopy on Central. Enjoy our 24-hour fitness and cardio center along with a variety of other top-tier amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness and cardio center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with 24-Hour Fitness & Cardio Center",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with 24-hour fitness & cardio center, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-clubhouse-business-center",
      "search_query": "Apartments For Rent Near Me with Clubhouse & Business Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Clubhouse & Business Center",
      "h2_subtitle": "Find your perfect home at Canopy on Central. Enjoy our clubhouse and business center along with a range of other exceptional amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Additionally, our clubhouse and business center provide the perfect spaces for socializing and productivity. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with Clubhouse & Business Center",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with clubhouse & business center, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-concierge-cleaning-services",
      "search_query": "Apartments For Rent Near Me with Concierge Cleaning Services Available by Spruce",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Concierge Cleaning Services Available by Spruce",
      "h2_subtitle": "Experience unparalleled convenience at Canopy on Central. Enjoy concierge cleaning services available by Spruce along with a host of other premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Additionally, our concierge cleaning services available by Spruce ensure your home stays spotless without the hassle. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with Concierge Cleaning Services Available by Spruce",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with concierge cleaning services available by Spruce, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-online-resident-services",
      "search_query": "Apartments For Rent Near Me with Convenient 24/7 Online Resident Services",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Convenient 24/7 Online Resident Services",
      "h2_subtitle": "Enjoy modern living at Canopy on Central. Our convenient 24/7 online resident services make managing your home easier than ever.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Additionally, our convenient 24/7 online resident services allow you to manage your home with ease, from paying rent to submitting maintenance requests. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with Convenient 24/7 Online Resident Services",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with convenient 24/7 online resident services, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-spacious-closets",
      "search_query": "Apartments For Rent Near Me with Spacious Closets",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Spacious Closets",
      "h2_subtitle": "Discover the perfect home at Canopy on Central. Our apartments feature spacious closets and a range of other premium amenities for your comfort.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Additionally, our apartments come with spacious closets, providing ample storage for all your belongings. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with Spacious Closets",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with spacious closets, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-private-patio-balcony",
      "search_query": "Apartments For Rent Near Me with Private Patio or Balcony",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Private Patio or Balcony",
      "h2_subtitle": "Enjoy outdoor living at Canopy on Central. Our apartments feature private patios or balconies along with a variety of other premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Additionally, our apartments come with private patios or balconies, perfect for enjoying the outdoors from the comfort of your home. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with Private Patio or Balcony",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with private patio or balcony, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-full-size-washer-dryer-connections",
      "search_query": "Apartments For Rent Near Me with Full-Size Washer & Dryer Connections*",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Full-Size Washer & Dryer Connections*",
      "h2_subtitle": "Experience convenience at Canopy on Central. Our apartments feature full-size washer and dryer connections* along with a range of other premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Additionally, our apartments come with full-size washer and dryer connections*, making laundry day a breeze. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with Full-Size Washer & Dryer Connections*",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with full-size washer & dryer connections*, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-premium-appliances",
      "search_query": "Apartments For Rent Near Me with Premium Appliances & Dishwasher",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Premium Appliances & Dishwasher",
      "h2_subtitle": "Discover modern living at Canopy on Central. Our apartments feature premium appliances and a convenient dishwasher along with a variety of other amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with premium appliances and a convenient dishwasher, as well as a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with Premium Appliances & Dishwasher",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with premium appliances & dishwasher, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-hardwood-style-flooring",
      "search_query": "Apartments For Rent Near Me with Hardwood-Style Flooring",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Hardwood-Style Flooring",
      "h2_subtitle": "Experience elegance at Canopy on Central. Our apartments feature hardwood-style flooring* along with a range of other premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Additionally, our apartments come with hardwood-style flooring*, adding a touch of elegance to your living space. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent Near Me with Hardwood-Style Flooring",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent near me with hardwood-style flooring, premium amenities, and a prime location in Bedford, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-bedford-tx-near-dallas-college",
      "search_query": "Apartments For Rent In Bedford TX Near Dallas College North Lake Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Bedford TX Near Dallas College North Lake Campus",
      "h2_subtitle": "Discover your ideal home at Canopy on Central. Our apartments offer convenient access to Dallas College North Lake Campus and a range of premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Located near Dallas College North Lake Campus, our community provides easy access to educational opportunities for residents. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent In Bedford TX Near Dallas College North Lake Campus",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent in Bedford TX near Dallas College North Lake Campus, featuring premium amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-bedford-tx-near-uti",
      "search_query": "Apartments For Rent In Bedford TX Near Universal Technical Institute",
      "category": "POI",
      "h1_title": "Apartments For Rent In Bedford TX Near Universal Technical Institute",
      "h2_subtitle": "Find your perfect home at Canopy on Central. Our apartments offer convenient access to Universal Technical Institute and a range of premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Located near Universal Technical Institute, our community provides easy access to top-notch technical education for residents. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent In Bedford TX Near Universal Technical Institute",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent in Bedford TX near Universal Technical Institute, featuring premium amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-bedford-tx-near-tarrant-county",
      "search_query": "Apartments For Rent In Bedford TX Near Tarrant County College District Office",
      "category": "POI",
      "h1_title": "Apartments For Rent In Bedford TX Near Tarrant County College District Office",
      "h2_subtitle": "Discover your ideal home at Canopy on Central. Our apartments offer convenient access to Tarrant County College District Office and a range of premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Located near Tarrant County College District Office, our community provides easy access to educational and administrative services. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent In Bedford TX Near Tarrant County College District Office",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent in Bedford TX near Tarrant County College District Office, featuring premium amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-bedford-tx-near-university",
      "search_query": "Apartments For Rent In Bedford TX Near University of Dallas",
      "category": "POI",
      "h1_title": "Apartments For Rent In Bedford TX Near University of Dallas",
      "h2_subtitle": "Find your perfect home at Canopy on Central. Our apartments offer convenient access to the University of Dallas and a range of premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Located near the University of Dallas, our community provides easy access to educational opportunities for residents. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent In Bedford TX Near University of Dallas",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent in Bedford TX near University of Dallas, featuring premium amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-bedford-tx-near-dbu",
      "search_query": "Apartments For Rent In Bedford TX Near Dallas Baptist University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Bedford TX Near Dallas Baptist University",
      "h2_subtitle": "Discover your ideal home at Canopy on Central. Our apartments offer convenient access to Dallas Baptist University and a range of premium amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Located near Dallas Baptist University, our community provides easy access to educational opportunities for residents. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent In Bedford TX Near Dallas Baptist University",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent in Bedford TX near Dallas Baptist University, featuring premium amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-in-bedford-tx-near-shady-brook",
      "search_query": "Apartments For Rent In Bedford TX Near Shady Brook Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Bedford TX Near Shady Brook Elementary School",
      "h2_subtitle": "Find your family’s perfect home at Canopy on Central. Our apartments offer convenient access to Shady Brook Elementary School and a range of family-friendly amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. Families will appreciate the close proximity to Shady Brook Elementary School, just 2.7 km away, making school commutes a breeze. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent In Bedford TX Near Shady Brook Elementary School",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent in Bedford TX near Shady Brook Elementary School, featuring family-friendly amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-bedford-tx-near-harwood-junior",
      "search_query": "Apartments For Rent In Bedford TX Near Harwood Junior High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Bedford TX Near Harwood Junior High School",
      "h2_subtitle": "Discover your family’s ideal home at Canopy on Central. Our apartments offer convenient access to Harwood Junior High School and a range of family-friendly amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. Families will appreciate the close proximity to Harwood Junior High School, just 2.1 km away, making school commutes easy and stress-free. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent In Bedford TX Near Harwood Junior High School",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent in Bedford TX near Harwood Junior High School, featuring family-friendly amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5761334570385408",
      "source": "custom",
      "page_item_url": "apartments-for-rent-bedford-tx-near-trinity-high-school",
      "search_query": "Apartments For Rent In Bedford TX Near Trinity High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Bedford TX Near Trinity High School",
      "h2_subtitle": "Find your family’s perfect home at Canopy on Central. Our apartments offer convenient access to Trinity High School and a range of family-friendly amenities.",
      "page_copy": "Let Canopy on Central help you find a living space you love to call home. Select your favorite floor plan from our one and two-bedroom apartments for rent in Bedford, TX. Situated along Central Drive, our garden-style apartment homes feature a long list of in-home highlights, including a fully equipped chef’s kitchen with a convenient dishwasher and a cozy and inviting wood-burning fireplace. Families will appreciate the close proximity to Trinity High School, just 5.1 km away, making school commutes easy and stress-free. You’ll also gain access to our full collection of amenities. Jump-start your cardio and exercise routine at the 24-hour fitness center, and take your downtime to the next level at one of our five resort-style outdoor swimming pools and sundecks. Canopy on Central is an apartment community managed by American Landmark, located in Tarrant County and the 76021 ZIP Code. This area is served by the Hurst-Euless-Bedford Independent attendance zone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a gazebo.",
        "public_id": "019f6c0c-e9e9-75cf-9cb5-9e861223e216",
        "storage_key": "property/5761334570385408/019f6c0c-e9e9-75cf-9cb5-9e861223e216.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c0c-f5e9-7755-af76-f45e84faf9f2",
        "storage_key": "property/5761334570385408/019f6c0c-f5e9-7755-af76-f45e84faf9f2.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Canopy on Central | Apartments For Rent In Bedford TX Near Trinity High School",
      "seo_description": "Discover Canopy on Central. Explore apartments for rent in Bedford TX near Trinity High School, featuring family-friendly amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2147"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471324"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a1c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a1c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4600731"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KH8SHVV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://canopyonce.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443897720"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/910pdok7v2z"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/9161d032-d771-492a-bf0a-c2b318b303ad"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-952-5068"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imt1bnZWaVhyWHNSVjFET1NmcTg4QUE9PSIsInZhbHVlIjoiNHcwWFQ2WFByc0dQRWFCczVWL3Exdz09IiwibWFjIjoiNzRmZmE2MTY0ZmQ3MGI4NDhkZmY3NjgyZjlhYWMyNzViYzJkNzFlYmJlNzBjYzA3YjA0MzhmOTI2ZTgzMjg0NCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2147",
  "custom_repli_id": "2376471324",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a1c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a1c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4600731",
  "custom_google_gtm_id": "GTM-KH8SHVV",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://canopyonce.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443897720",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/910pdok7v2z",
  "custom_self_guided_tour_url": "https://selftournow.com/property/9161d032-d771-492a-bf0a-c2b318b303ad",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-952-5068",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imt1bnZWaVhyWHNSVjFET1NmcTg4QUE9PSIsInZhbHVlIjoiNHcwWFQ2WFByc0dQRWFCczVWL3Exdz09IiwibWFjIjoiNzRmZmE2MTY0ZmQ3MGI4NDhkZmY3NjgyZjlhYWMyNzViYzJkNzFlYmJlNzBjYzA3YjA0MzhmOTI2ZTgzMjg0NCJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "1f065153-d13a-4c65-8fb2-1c03701e6c56",
  "custom_audioeye_site_hash": "e388ca8aec5d5be30e3475468a4ad221"
};

export const generatedAt = '2026-11-03T20:38:31.493Z';
